var $n = Object.defineProperty, er = Object.defineProperties;
var tr = Object.getOwnPropertyDescriptors;
var Re = Object.getOwnPropertySymbols;
var Ot = Object.prototype.hasOwnProperty, Pt = Object.prototype.propertyIsEnumerable;
var Kt = (e, n, t) => n in e ? $n(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, N = (e, n) => {
  for (var t in n || (n = {}))
    Ot.call(n, t) && Kt(e, t, n[t]);
  if (Re)
    for (var t of Re(n))
      Pt.call(n, t) && Kt(e, t, n[t]);
  return e;
}, Y = (e, n) => er(e, tr(n));
var X = (e, n) => {
  var t = {};
  for (var a in e)
    Ot.call(e, a) && n.indexOf(a) < 0 && (t[a] = e[a]);
  if (e != null && Re)
    for (var a of Re(e))
      n.indexOf(a) < 0 && Pt.call(e, a) && (t[a] = e[a]);
  return t;
};
import * as q from "react";
import r, { createContext as nr, useContext as rr, useEffect as re, useState as J, useMemo as ne, useCallback as Lt } from "react";
import { Spin as ar, ConfigProvider as En, Steps as or, Tooltip as Mt, Popconfirm as fn, Button as un, Input as hn, Table as mn, Checkbox as ir, DatePicker as Ht, Dropdown as lr, Skeleton as gn, Select as cr } from "antd";
import m, { css as ye } from "styled-components";
var Cn = /* @__PURE__ */ ((e) => (e.FIELD_STEP_CONTAINER = "FIELD_STEP_CONTAINER", e))(Cn || {}), Te = /* @__PURE__ */ ((e) => (e.SETUP_FORM_STEP_CONTAINER = "SETUP_FORM_STEP_CONTAINER", e.SETUP_FORM_STEP_NEXT_BUTTON = "SETUP_FORM_STEP_NEXT_BUTTON", e.SETUP_FORM_STEP_PREVIOUS_BUTTON = "SETUP_FORM_STEP_PREVIOUS_BUTTON", e.SETUP_FORM_STEP_TITLE = "SETUP_FORM_STEP_TITLE", e.SETUP_FORM_STEP_SUB_TITLE = "SETUP_FORM_STEP_SUB_TITLE", e))(Te || {}), dt = /* @__PURE__ */ ((e) => (e.HEADER_CONTAINER = "HEADER_CONTAINER", e.HEADER_STEPS = "HEADER_STEPS", e.HEADER_CUSTOM = "HEADER_CUSTOM", e))(dt || {}), Et = /* @__PURE__ */ ((e) => (e.SETUP_FORM_CONTAINER = "SETUP_FORM_CONTAINER", e.SETUP_FORM_LOADING = "SETUP_FORM_LOADING", e))(Et || {}), Fe = /* @__PURE__ */ ((e) => (e.SEASON_STEP_CONTAINER = "SEASON_STEP_CONTAINER", e.SEASON_STEP_CHECKBOX = "SEASON_STEP_CHECKBOX", e.SEASON_STEP_START_DATE = "SEASON_STEP_START_DATE", e.SEASON_STEP_END_DATE = "SEASON_STEP_END_DATE", e))(Fe || {}), An = /* @__PURE__ */ ((e) => (e.SETUP_FORM_END_SEASON_BUTTON = "SETUP_FORM_END_SEASON_BUTTON", e))(An || {}), Ye = /* @__PURE__ */ ((e) => (e.NEMA_CTA_CONTAINER = "NEMA_CTA_CONTAINER", e.NEMA_CTA_BUTTON = "NEMA_CTA_BUTTON", e.NEMA_CTA_CLOSE_BUTTON = "NEMA_CTA_CLOSE_BUTTON", e))(Ye || {}), ft = /* @__PURE__ */ ((e) => (e.NEMA_MAP_STATUS_ERROR = "NEMA_MAP_STATUS_ERROR", e.NEMA_MAP_STATUS_LOADING = "NEMA_MAP_STATUS_LOADING", e))(ft || {}), Ge = /* @__PURE__ */ ((e) => (e.NEMA_SELECT_SEASON_CONTAINER = "NEMA_SELECT_SEASON_CONTAINER", e.NEMA_SELECT_SEASON_PREVIOUS_BUTTON = "NEMA_SELECT_SEASON_PREVIOUS_BUTTON", e.NEMA_SELECT_SEASON_NEXT_BUTTON = "NEMA_SELECT_SEASON_NEXT_BUTTON", e))(Ge || {}), pn = /* @__PURE__ */ ((e) => (e.EDIT_FIELD_CROP_BODY = "EDIT_FIELD_CROP_BODY", e))(pn || {}), ut = /* @__PURE__ */ ((e) => (e.HEADER_EDIT_FIELD_CROP_CANCEL = "HEADER_EDIT_FIELD_CROP_CANCEL", e.HEADER_EDIT_FIELD_CROP_SAVE = "HEADER_EDIT_FIELD_CROP_SAVE", e))(ut || {}), Ue = /* @__PURE__ */ ((e) => (e.EDIT_FIELD_CROP_SEASON_TITLE = "EDIT_FIELD_CROP_SEASON_TITLE", e.PAST_SEASON_COLUMN_TITLE_CONTAINER = "PAST_SEASON_COLUMN_TITLE_CONTAINER", e.CURRENT_SEASON_COLUMN_TITLE_CONTAINER = "CURRENT_SEASON_COLUMN_TITLE_CONTAINER", e.SEASON_COLUMN_CARD_CONTAINER = "SEASON_COLUMN_CARD_CONTAINER", e.SEASON_COLUMN_CELL_CONTAINER = "SEASON_COLUMN_CELL_CONTAINER", e))(Ue || {}), Ve = /* @__PURE__ */ ((e) => (e.DATE_EDIT_TITLE_CONTAINER = "DATE_EDIT_TITLE_CONTAINER", e.DATE_EDIT_TITLE_TEXT = "DATE_EDIT_TITLE_TEXT", e.DATE_EDIT_TITLE_ICON = "DATE_EDIT_TITLE_ICON", e))(Ve || {}), Ce = /* @__PURE__ */ ((e) => (e.MONTH_CALENDAR_CONTAINER = "MONTH_CALENDAR_CONTAINER", e.MONTH_CALENDAR_TITLE = "MONTH_CALENDAR_TITLE", e.MONTH_CALENDAR_DATE = "MONTH_CALENDAR_DATE", e.MONTH_CALENDAR_LEFT_ARROW = "MONTH_CALENDAR_LEFT_ARROW", e.MONTH_CALENDAR_RIGHT_ARROW = "MONTH_CALENDAR_RIGHT_ARROW", e.MONTH_CALENDAR_BOX_MONTH = "MONTH_CALENDAR_BOX_MONTH", e))(Ce || {}), we = /* @__PURE__ */ ((e) => (e.DATE_EDIT_MODAL_BODY = "DATE_EDIT_MODAL_BODY", e.DATE_EDIT_MODAL_SHADOW = "DATE_EDIT_MODAL_SHADOW", e.DATE_EDIT_MODAL_SAVE = "DATE_EDIT_MODAL_SAVE", e.DATE_EDIT_MODAL_CANCEL = "DATE_EDIT_MODAL_CANCEL", e))(we || {}), Qe = /* @__PURE__ */ ((e) => (e.NEMA_CDL_CONTAINER = "NEMA_CDL_CONTAINER", e.NEMA_CDL_HEADER = "NEMA_CDL_HEADER", e.NEMA_CDL_TITLE = "NEMA_CDL_TITLE", e.NEMA_CDL_SUB_TITLE = "NEMA_CDL_SUB_TITLE", e.NEMA_CDL_DESCRIPTION = "NEMA_CDL_DESCRIPTION", e.NEMA_CDL_SUB_DESCRIPTION = "NEMA_CDL_SUB_DESCRIPTION", e.NEMA_CDL_CANCEL_BUTTON = "NEMA_CDL_CANCEL_BUTTON", e.NEMA_CDL_OK_BUTTON = "NEMA_CDL_OK_BUTTON", e))(Qe || {});
const vt = (n) => {
  var e = X(n, []);
  return /* @__PURE__ */ r.createElement(ar, N({}, e));
};
var j = /* @__PURE__ */ ((e) => (e.PRIMARY = "#2f3031", e.SECONDARY = "#707374", e.SUCCESS = "#198746", e.DANGER = "#F74141", e.SEVERITY_BG = "#FFECEC", e.WHITE = "#FFFFFF", e.BLUE_PRIMARY = "#01658d", e.BLUE_10 = "#EAF6FF", e.BLUE_20 = "#C6E6FF", e.BLUE_30 = "#82CFFF", e.BLUE_40 = "#31B4F2", e.BLUE_50 = "#0092E4", e.BLUE_60 = "#0071CD", e.BLUE_70 = "#005693", e.BLUE_80 = "#003B69", e.BLUE_90 = "#002747", e.YELLOW_PRIMARY = "#ffca28", e.YELLOW_10 = "#FFF3DD", e.YELLOW_20 = "#FFE4AE", e.YELLOW_30 = "#F0C355", e.YELLOW_35 = "#FFDF4B", e.YELLOW_40 = "#E99921", e.YELLOW_50 = "#C17E19", e.YELLOW_60 = "#9A6412", e.YELLOW_70 = "#744A0B", e.YELLOW_80 = "#523305", e.ORANGE_20 = "#FFDACE", e.ORANGE_40 = "#FF785A", e.ORANGE_60 = "#C1462B", e.ORANGE_70 = "#92331E", e.DISABLED = "#8E9293", e.GRAY_7 = "#F5F8FC", e.GRAY_4 = "#C1C5C8", e.GRAY_2 = "#515253", e.GRAY_1 = "#2F3031", e.NEUTRAL_100 = "#14151C", e.NEUTRAL_90 = "#232630", e.NEUTRAL_80 = "#363948", e.NEUTRAL_70 = "#4D5165", e.NEUTRAL_60 = "#696F88", e.NEUTRAL_50 = "#868CA2", e.NEUTRAL_40 = "#A3A9B9", e.NEUTRAL_30 = "#C2C7D0", e.NEUTRAL_20 = "#DFE2E7", e.NEUTRAL_10 = "#F3F4F6", e.GREEN_5 = "#EDFEF0", e.GREEN_10 = "#DFFBE8", e.GREEN_40 = "#5EBB7F", e.GREEN_50 = "#19A04B", e.GREEN_60 = "#14803C", e.GREEN_70 = "#0C612C", e.GREEN_DAE = "#0B95A8", e.GREEN_PRIMARY = "#749205", e.GREEN_SECONDARY = "#1a8746", e.GREEN_CROPWISE = "#73DC78", e.LIGHT_GREEN = "#7ed66b", e.HARVESTED = "#2FB966", e.PINK_20 = "#FFD8DF", e.PINK_30 = "#FFB2C1", e.PINK_40 = "#FF7D96", e.PINK_60 = "#BB485D", e.PINK_70 = "#8D3545", e.PURPLE_20 = "#E7DDFC", e.PURPLE_30 = "#D2BDF9", e.PURPLE_50 = "#9664F0", e.PURPLE_70 = "#643AAA", e.PURPLE_90 = "#2E1954", e.RED_10 = "#FEF1F1", e.RED_30 = "#FFB3B3", e.RED_50 = "#EB4B4B", e.RED_60 = "#CF3537", e.RED_70 = "#9C2628", e.RED_80 = "#70191A", e.RED_100 = "#FF0000", e.TEAL_20 = "#A9EFE8", e.TEAL_30 = "#5FD2C8", e.TEAL_50 = "#2B9C92", e.TEAL_70 = "#165C56", e))(j || {});
const ze = ({ children: e }) => /* @__PURE__ */ r.createElement(
  En,
  {
    theme: {
      token: {
        colorPrimary: j.SUCCESS,
        colorPrimaryHover: j.SUCCESS
      }
    },
    prefixCls: "nemaant",
    iconPrefixCls: "nemaanticon"
  },
  e
), De = m.div`
  display: flex;
`, sr = m(De)`
  flex-direction: column;
`, dr = m(De)`
  align-items: center;
  justify-content: center;
`, Er = m(De)`
  align-items: center;
`, fr = m(De)`
  justify-content: center;
`, ur = m(De)`
  justify-content: space-between;
`, hr = m.div`
  width: ${(e) => e.width};
`, v = {
  Flex: De,
  FlexColumn: sr,
  FlexCenter: dr,
  FlexAlignCenter: Er,
  FlexJustifyCenter: fr,
  FlexJustifyBetween: ur,
  LimitedContainer: hr
}, mr = (e) => /* @__PURE__ */ r.createElement(or, N({}, e)), gr = (e) => ye`
  margin: 0px;
  ${e.$margin && `margin: ${e.$margin}`};
  ${e.$marginTop && `margin-top: ${e.$marginTop}`};
  ${e.$marginBottom && `margin-bottom: ${e.$marginBottom}`};
  ${e.$marginLeft && `margin-left: ${e.$marginLeft}`};
  ${e.$marginRight && `margin-right: ${e.$marginRight}`};
`, Cr = (e) => ye`
  ${e.$fontFamily && `font-family: ${e.$fontFamily}`};
  ${e.$fontSize && `font-size: ${e.$fontSize}`};
  ${e.$fontWeight && `font-weight: ${e.$fontWeight}`};
  ${e.$lineHeight && `line-height: ${e.$lineHeight}`};
  ${e.$color && `color: ${e.$color}`};
`, Ar = (e) => ye`
  ${e.$height && `height: ${e.$height}`};
  ${e.$width && `width: ${e.$width}`};
`, pr = (e) => ye`
  ${e.$position && `position: ${e.$position}`};
  ${e.$right && `right: ${e.$right}`};
  ${e.$left && `left: ${e.$left}`};
  ${e.$top && `top: ${e.$top}`};
  ${e.$bottom && `bottom: ${e.$bottom}`};
  ${e.$zIndex && `z-index: ${e.$zIndex}`};
`, Sr = (e) => ye`
  ${e.$backgroundColor && `background-color: ${e.$backgroundColor}`};
  ${e.$selected && e.$backgroundColor && e.$selectedBackgroundColor && `background-color: ${e.$selected ? e.$selectedBackgroundColor : e.$backgroundColor}`};
`, Tr = (e) => ye`
  ${e.$borderRadius && `border-radius: ${e.$borderRadius}`};
`, z = {
  MarginControl: gr,
  FontControl: Cr,
  SizeControl: Ar,
  PositionControl: pr,
  BackgroundControl: Sr,
  BorderControl: Tr
}, yr = m.h1`
  color: ${(e) => e.$color || "#14151c"};
  font: 600 24px Noto Sans, sans-serif;

  ${z.MarginControl}
  ${z.FontControl}
`, Dr = m.h2`
  color: ${(e) => e.$color || "#14151c"};
  font: 600 16px Noto Sans, sans-serif;

  ${z.MarginControl}
  ${z.FontControl}
`, ht = m.p`
  font: 400 14px Noto Sans, sans-serif;
  color: ${(e) => e.$color || "#14151c"};

  ${z.MarginControl}
  ${z.FontControl}
`, Nr = m.p`
  color: ${(e) => e.$color || "#14151c"};
  font: 600 12px Noto Sans, sans-serif;

  ${z.MarginControl}
  ${z.FontControl}
`, Br = m.p`
  color: ${(e) => e.$color};
  font: 600 14px Noto Sans, sans-serif;

  ${z.MarginControl}
  ${z.FontControl}
`, xr = m.p`
  color: ${(e) => e.$color};
  font: 400 12px Noto Sans, sans-serif;

  ${z.MarginControl}
  ${z.FontControl}
`, R = { Title: yr, SubTitle: Dr, Description: ht, Small: xr, SmallBold: Nr, Bold: Br }, Lr = m.svg`
  ${(e) => e.$cursor && `cursor: ${e.$cursor}`};
  ${z.MarginControl}
`, de = { SVG: Lr }, mt = (n) => {
  var e = X(n, []);
  return /* @__PURE__ */ r.createElement(de.SVG, N({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "#696F88" }, e), /* @__PURE__ */ r.createElement("path", { d: "M14 18a.997.997 0 01-.707-.293l-5-5a.999.999 0 010-1.414l5-5a.999.999 0 111.414 1.414L10.414 12l4.293 4.293A.999.999 0 0114 18" }));
}, Sn = ({ children: e, maxLength: n }) => {
  if (e.length <= n)
    return /* @__PURE__ */ r.createElement("div", null, e);
  {
    const t = (e == null ? void 0 : e.slice(0, n)) + "...";
    return /* @__PURE__ */ r.createElement(Mt, { title: e }, /* @__PURE__ */ r.createElement("div", { "data-testid": "nema-typo" }, t));
  }
}, Mr = (e, n, t, a) => e.map((i, o) => {
  const l = n <= o;
  return {
    title: /* @__PURE__ */ r.createElement(Sn, { maxLength: a }, i.nameStep),
    style: l ? void 0 : { cursor: "pointer" },
    onClick: l ? void 0 : () => t(o)
  };
}), vr = (n) => {
  var e = X(n, []);
  return /* @__PURE__ */ r.createElement(de.SVG, N({ width: "16", height: "16", viewBox: "0 0 16 16" }, e), /* @__PURE__ */ r.createElement("path", { d: "M8 16A8 8 0 118 0a8 8 0 010 16zm0-3a1 1 0 100-2 1 1 0 000 2zM8 3a1 1 0 00-1 1v5a1 1 0 102 0V4a1 1 0 00-1-1z" }));
}, Ft = ({
  translation: e,
  disabled: n,
  placement: t = "bottomLeft",
  children: a,
  onBackConfirm: i
}) => /* @__PURE__ */ r.createElement(
  fn,
  {
    icon: /* @__PURE__ */ r.createElement(vr, { fill: "#E99921" }),
    placement: t,
    disabled: n,
    title: /* @__PURE__ */ r.createElement("div", null, /* @__PURE__ */ r.createElement(R.Description, null, e.backPopConfirmTitle), /* @__PURE__ */ r.createElement(R.Description, null, e.backPopConfirmCTAText)),
    okText: e.backPopConfirmConfirmButton,
    cancelText: e.backPopConfirmCancelButton,
    onConfirm: i
  },
  a
), Fr = m.header`
  display: flex;
  justify-content: space-between;
  align-items: center;

  background-color: #ffffff;

  height: 56px;

  border-bottom: 1px solid #dfe2e7;
  padding: 8px 24px;
  margin-bottom: 0px;
  overflow: auto;
`, wr = m.div`
  width: 100%;
  margin-left: 56px;
`, Ir = m.div`
  width: max-content;
`, We = { ContainerHeader: Fr, ContainerSteps: wr, ContainerTitle: Ir };
var Ur = /* @__PURE__ */ nr({});
const Tn = Ur;
function Ae(e) {
  return Ae = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ae(e);
}
function br(e, n) {
  if (Ae(e) !== "object" || e === null)
    return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, n || "default");
    if (Ae(a) !== "object")
      return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(e);
}
function Rr(e) {
  var n = br(e, "string");
  return Ae(n) === "symbol" ? n : String(n);
}
function gt(e, n, t) {
  return n = Rr(n), n in e ? Object.defineProperty(e, n, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = t, e;
}
function Yt(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    n && (a = a.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), t.push.apply(t, a);
  }
  return t;
}
function _(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Yt(Object(t), !0).forEach(function(a) {
      gt(e, a, t[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Yt(Object(t)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(t, a));
    });
  }
  return e;
}
function kr(e) {
  if (Array.isArray(e))
    return e;
}
function Kr(e, n) {
  var t = e == null ? null : typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var a, i, o, l, c = [], s = !0, d = !1;
    try {
      if (o = (t = t.call(e)).next, n === 0) {
        if (Object(t) !== t)
          return;
        s = !1;
      } else
        for (; !(s = (a = o.call(t)).done) && (c.push(a.value), c.length !== n); s = !0)
          ;
    } catch (E) {
      d = !0, i = E;
    } finally {
      try {
        if (!s && t.return != null && (l = t.return(), Object(l) !== l))
          return;
      } finally {
        if (d)
          throw i;
      }
    }
    return c;
  }
}
function Gt(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, a = new Array(n); t < n; t++)
    a[t] = e[t];
  return a;
}
function Or(e, n) {
  if (e) {
    if (typeof e == "string")
      return Gt(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return Gt(e, n);
  }
}
function Pr() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function yn(e, n) {
  return kr(e) || Kr(e, n) || Or(e, n) || Pr();
}
function Hr(e, n) {
  if (e == null)
    return {};
  var t = {}, a = Object.keys(e), i, o;
  for (o = 0; o < a.length; o++)
    i = a[o], !(n.indexOf(i) >= 0) && (t[i] = e[i]);
  return t;
}
function Dn(e, n) {
  if (e == null)
    return {};
  var t = Hr(e, n), a, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      a = o[i], !(n.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(e, a) && (t[a] = e[a]);
  }
  return t;
}
var Nn = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {}, Ct = {}, Yr = {
  get exports() {
    return Ct;
  },
  set exports(e) {
    Ct = e;
  }
};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var n = {}.hasOwnProperty;
    function t() {
      for (var a = [], i = 0; i < arguments.length; i++) {
        var o = arguments[i];
        if (o) {
          var l = typeof o;
          if (l === "string" || l === "number")
            a.push(o);
          else if (Array.isArray(o)) {
            if (o.length) {
              var c = t.apply(null, o);
              c && a.push(c);
            }
          } else if (l === "object") {
            if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]")) {
              a.push(o.toString());
              continue;
            }
            for (var s in o)
              n.call(o, s) && o[s] && a.push(s);
          }
        }
      }
      return a.join(" ");
    }
    e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
  })();
})(Yr);
const Gr = Ct;
function ae(e, n) {
  Vr(e) && (e = "100%");
  var t = Qr(e);
  return e = n === 360 ? e : Math.min(n, Math.max(0, parseFloat(e))), t && (e = parseInt(String(e * n), 10) / 100), Math.abs(e - n) < 1e-6 ? 1 : (n === 360 ? e = (e < 0 ? e % n + n : e % n) / parseFloat(String(n)) : e = e % n / parseFloat(String(n)), e);
}
function Vr(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function Qr(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function Jr(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function ke(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function Xe(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function _r(e, n, t) {
  return {
    r: ae(e, 255) * 255,
    g: ae(n, 255) * 255,
    b: ae(t, 255) * 255
  };
}
function $e(e, n, t) {
  return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? e + (n - e) * (6 * t) : t < 1 / 2 ? n : t < 2 / 3 ? e + (n - e) * (2 / 3 - t) * 6 : e;
}
function zr(e, n, t) {
  var a, i, o;
  if (e = ae(e, 360), n = ae(n, 100), t = ae(t, 100), n === 0)
    i = t, o = t, a = t;
  else {
    var l = t < 0.5 ? t * (1 + n) : t + n - t * n, c = 2 * t - l;
    a = $e(c, l, e + 1 / 3), i = $e(c, l, e), o = $e(c, l, e - 1 / 3);
  }
  return { r: a * 255, g: i * 255, b: o * 255 };
}
function jr(e, n, t) {
  e = ae(e, 255), n = ae(n, 255), t = ae(t, 255);
  var a = Math.max(e, n, t), i = Math.min(e, n, t), o = 0, l = a, c = a - i, s = a === 0 ? 0 : c / a;
  if (a === i)
    o = 0;
  else {
    switch (a) {
      case e:
        o = (n - t) / c + (n < t ? 6 : 0);
        break;
      case n:
        o = (t - e) / c + 2;
        break;
      case t:
        o = (e - n) / c + 4;
        break;
    }
    o /= 6;
  }
  return { h: o, s, v: l };
}
function Zr(e, n, t) {
  e = ae(e, 360) * 6, n = ae(n, 100), t = ae(t, 100);
  var a = Math.floor(e), i = e - a, o = t * (1 - n), l = t * (1 - i * n), c = t * (1 - (1 - i) * n), s = a % 6, d = [t, l, o, o, c, t][s], E = [c, t, t, l, o, o][s], f = [o, o, c, t, t, l][s];
  return { r: d * 255, g: E * 255, b: f * 255 };
}
function qr(e, n, t, a) {
  var i = [
    Xe(Math.round(e).toString(16)),
    Xe(Math.round(n).toString(16)),
    Xe(Math.round(t).toString(16))
  ];
  return a && i[0].startsWith(i[0].charAt(1)) && i[1].startsWith(i[1].charAt(1)) && i[2].startsWith(i[2].charAt(1)) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
}
function Vt(e) {
  return ee(e) / 255;
}
function ee(e) {
  return parseInt(e, 16);
}
var Qt = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function xe(e) {
  var n = { r: 0, g: 0, b: 0 }, t = 1, a = null, i = null, o = null, l = !1, c = !1;
  return typeof e == "string" && (e = $r(e)), typeof e == "object" && (fe(e.r) && fe(e.g) && fe(e.b) ? (n = _r(e.r, e.g, e.b), l = !0, c = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : fe(e.h) && fe(e.s) && fe(e.v) ? (a = ke(e.s), i = ke(e.v), n = Zr(e.h, a, i), l = !0, c = "hsv") : fe(e.h) && fe(e.s) && fe(e.l) && (a = ke(e.s), o = ke(e.l), n = zr(e.h, a, o), l = !0, c = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (t = e.a)), t = Jr(t), {
    ok: l,
    format: e.format || c,
    r: Math.min(255, Math.max(n.r, 0)),
    g: Math.min(255, Math.max(n.g, 0)),
    b: Math.min(255, Math.max(n.b, 0)),
    a: t
  };
}
var Wr = "[-\\+]?\\d+%?", Xr = "[-\\+]?\\d*\\.\\d+%?", ge = "(?:".concat(Xr, ")|(?:").concat(Wr, ")"), et = "[\\s|\\(]+(".concat(ge, ")[,|\\s]+(").concat(ge, ")[,|\\s]+(").concat(ge, ")\\s*\\)?"), tt = "[\\s|\\(]+(".concat(ge, ")[,|\\s]+(").concat(ge, ")[,|\\s]+(").concat(ge, ")[,|\\s]+(").concat(ge, ")\\s*\\)?"), ie = {
  CSS_UNIT: new RegExp(ge),
  rgb: new RegExp("rgb" + et),
  rgba: new RegExp("rgba" + tt),
  hsl: new RegExp("hsl" + et),
  hsla: new RegExp("hsla" + tt),
  hsv: new RegExp("hsv" + et),
  hsva: new RegExp("hsva" + tt),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function $r(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var n = !1;
  if (Qt[e])
    e = Qt[e], n = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var t = ie.rgb.exec(e);
  return t ? { r: t[1], g: t[2], b: t[3] } : (t = ie.rgba.exec(e), t ? { r: t[1], g: t[2], b: t[3], a: t[4] } : (t = ie.hsl.exec(e), t ? { h: t[1], s: t[2], l: t[3] } : (t = ie.hsla.exec(e), t ? { h: t[1], s: t[2], l: t[3], a: t[4] } : (t = ie.hsv.exec(e), t ? { h: t[1], s: t[2], v: t[3] } : (t = ie.hsva.exec(e), t ? { h: t[1], s: t[2], v: t[3], a: t[4] } : (t = ie.hex8.exec(e), t ? {
    r: ee(t[1]),
    g: ee(t[2]),
    b: ee(t[3]),
    a: Vt(t[4]),
    format: n ? "name" : "hex8"
  } : (t = ie.hex6.exec(e), t ? {
    r: ee(t[1]),
    g: ee(t[2]),
    b: ee(t[3]),
    format: n ? "name" : "hex"
  } : (t = ie.hex4.exec(e), t ? {
    r: ee(t[1] + t[1]),
    g: ee(t[2] + t[2]),
    b: ee(t[3] + t[3]),
    a: Vt(t[4] + t[4]),
    format: n ? "name" : "hex8"
  } : (t = ie.hex3.exec(e), t ? {
    r: ee(t[1] + t[1]),
    g: ee(t[2] + t[2]),
    b: ee(t[3] + t[3]),
    format: n ? "name" : "hex"
  } : !1)))))))));
}
function fe(e) {
  return !!ie.CSS_UNIT.exec(String(e));
}
var Ke = 2, Jt = 0.16, ea = 0.05, ta = 0.05, na = 0.15, Bn = 5, xn = 4, ra = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}];
function _t(e) {
  var n = e.r, t = e.g, a = e.b, i = jr(n, t, a);
  return {
    h: i.h * 360,
    s: i.s,
    v: i.v
  };
}
function Oe(e) {
  var n = e.r, t = e.g, a = e.b;
  return "#".concat(qr(n, t, a, !1));
}
function aa(e, n, t) {
  var a = t / 100, i = {
    r: (n.r - e.r) * a + e.r,
    g: (n.g - e.g) * a + e.g,
    b: (n.b - e.b) * a + e.b
  };
  return i;
}
function zt(e, n, t) {
  var a;
  return Math.round(e.h) >= 60 && Math.round(e.h) <= 240 ? a = t ? Math.round(e.h) - Ke * n : Math.round(e.h) + Ke * n : a = t ? Math.round(e.h) + Ke * n : Math.round(e.h) - Ke * n, a < 0 ? a += 360 : a >= 360 && (a -= 360), a;
}
function jt(e, n, t) {
  if (e.h === 0 && e.s === 0)
    return e.s;
  var a;
  return t ? a = e.s - Jt * n : n === xn ? a = e.s + Jt : a = e.s + ea * n, a > 1 && (a = 1), t && n === Bn && a > 0.1 && (a = 0.1), a < 0.06 && (a = 0.06), Number(a.toFixed(2));
}
function Zt(e, n, t) {
  var a;
  return t ? a = e.v + ta * n : a = e.v - na * n, a > 1 && (a = 1), Number(a.toFixed(2));
}
function At(e) {
  for (var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = [], a = xe(e), i = Bn; i > 0; i -= 1) {
    var o = _t(a), l = Oe(xe({
      h: zt(o, i, !0),
      s: jt(o, i, !0),
      v: Zt(o, i, !0)
    }));
    t.push(l);
  }
  t.push(Oe(a));
  for (var c = 1; c <= xn; c += 1) {
    var s = _t(a), d = Oe(xe({
      h: zt(s, c),
      s: jt(s, c),
      v: Zt(s, c)
    }));
    t.push(d);
  }
  return n.theme === "dark" ? ra.map(function(E) {
    var f = E.index, T = E.opacity, h = Oe(aa(xe(n.backgroundColor || "#141414"), xe(t[f]), T * 100));
    return h;
  }) : t;
}
var nt = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1677FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, rt = {}, at = {};
Object.keys(nt).forEach(function(e) {
  rt[e] = At(nt[e]), rt[e].primary = rt[e][5], at[e] = At(nt[e], {
    theme: "dark",
    backgroundColor: "#141414"
  }), at[e].primary = at[e][5];
});
var qt = {};
function oa(e, n) {
  process.env.NODE_ENV !== "production" && !e && console !== void 0 && console.error("Warning: ".concat(n));
}
function ia(e, n, t) {
  !n && !qt[t] && (e(!1, t), qt[t] = !0);
}
function la(e, n) {
  ia(oa, e, n);
}
function ca() {
  return !!(typeof window != "undefined" && window.document && window.document.createElement);
}
function sa(e, n) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(n);
  for (var t = n; t; ) {
    if (t === e)
      return !0;
    t = t.parentNode;
  }
  return !1;
}
var Wt = "data-rc-order", da = "rc-util-key", pt = /* @__PURE__ */ new Map();
function Ln() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.mark;
  return n ? n.startsWith("data-") ? n : "data-".concat(n) : da;
}
function wt(e) {
  if (e.attachTo)
    return e.attachTo;
  var n = document.querySelector("head");
  return n || document.body;
}
function Ea(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function Mn(e) {
  return Array.from((pt.get(e) || e).children).filter(function(n) {
    return n.tagName === "STYLE";
  });
}
function vn(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!ca())
    return null;
  var t = n.csp, a = n.prepend, i = document.createElement("style");
  i.setAttribute(Wt, Ea(a)), t != null && t.nonce && (i.nonce = t == null ? void 0 : t.nonce), i.innerHTML = e;
  var o = wt(n), l = o.firstChild;
  if (a) {
    if (a === "queue") {
      var c = Mn(o).filter(function(s) {
        return ["prepend", "prependQueue"].includes(s.getAttribute(Wt));
      });
      if (c.length)
        return o.insertBefore(i, c[c.length - 1].nextSibling), i;
    }
    o.insertBefore(i, l);
  } else
    o.appendChild(i);
  return i;
}
function fa(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = wt(n);
  return Mn(t).find(function(a) {
    return a.getAttribute(Ln(n)) === e;
  });
}
function ua(e, n) {
  var t = pt.get(e);
  if (!t || !sa(document, t)) {
    var a = vn("", n), i = a.parentNode;
    pt.set(e, i), e.removeChild(a);
  }
}
function ha(e, n) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = wt(t);
  ua(a, t);
  var i = fa(n, t);
  if (i) {
    var o, l;
    if ((o = t.csp) !== null && o !== void 0 && o.nonce && i.nonce !== ((l = t.csp) === null || l === void 0 ? void 0 : l.nonce)) {
      var c;
      i.nonce = (c = t.csp) === null || c === void 0 ? void 0 : c.nonce;
    }
    return i.innerHTML !== e && (i.innerHTML = e), i;
  }
  var s = vn(e, t);
  return s.setAttribute(Ln(t), n), s;
}
function ma(e, n) {
  la(e, "[@ant-design/icons] ".concat(n));
}
function Xt(e) {
  return Ae(e) === "object" && typeof e.name == "string" && typeof e.theme == "string" && (Ae(e.icon) === "object" || typeof e.icon == "function");
}
function $t() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(e).reduce(function(n, t) {
    var a = e[t];
    switch (t) {
      case "class":
        n.className = a, delete n.class;
        break;
      default:
        n[t] = a;
    }
    return n;
  }, {});
}
function St(e, n, t) {
  return t ? /* @__PURE__ */ r.createElement(e.tag, _(_({
    key: n
  }, $t(e.attrs)), t), (e.children || []).map(function(a, i) {
    return St(a, "".concat(n, "-").concat(e.tag, "-").concat(i));
  })) : /* @__PURE__ */ r.createElement(e.tag, _({
    key: n
  }, $t(e.attrs)), (e.children || []).map(function(a, i) {
    return St(a, "".concat(n, "-").concat(e.tag, "-").concat(i));
  }));
}
function Fn(e) {
  return At(e)[0];
}
function wn(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
var ga = `
.anticon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, Ca = function() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ga, t = rr(Tn), a = t.csp, i = t.prefixCls, o = n;
  i && (o = o.replace(/anticon/g, i)), re(function() {
    ha(o, "@ant-design-icons", {
      prepend: !0,
      csp: a
    });
  }, []);
}, Aa = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], Ie = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function pa(e) {
  var n = e.primaryColor, t = e.secondaryColor;
  Ie.primaryColor = n, Ie.secondaryColor = t || Fn(n), Ie.calculated = !!t;
}
function Sa() {
  return _({}, Ie);
}
var je = function(n) {
  var t = n.icon, a = n.className, i = n.onClick, o = n.style, l = n.primaryColor, c = n.secondaryColor, s = Dn(n, Aa), d = Ie;
  if (l && (d = {
    primaryColor: l,
    secondaryColor: c || Fn(l)
  }), Ca(), ma(Xt(t), "icon should be icon definiton, but got ".concat(t)), !Xt(t))
    return null;
  var E = t;
  return E && typeof E.icon == "function" && (E = _(_({}, E), {}, {
    icon: E.icon(d.primaryColor, d.secondaryColor)
  })), St(E.icon, "svg-".concat(E.name), _({
    className: a,
    onClick: i,
    style: o,
    "data-icon": E.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, s));
};
je.displayName = "IconReact";
je.getTwoToneColors = Sa;
je.setTwoToneColors = pa;
const It = je;
function In(e) {
  var n = wn(e), t = yn(n, 2), a = t[0], i = t[1];
  return It.setTwoToneColors({
    primaryColor: a,
    secondaryColor: i
  });
}
function Ta() {
  var e = It.getTwoToneColors();
  return e.calculated ? [e.primaryColor, e.secondaryColor] : e.primaryColor;
}
var ya = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
In("#1890ff");
var Ze = /* @__PURE__ */ q.forwardRef(function(e, n) {
  var t, a = e.className, i = e.icon, o = e.spin, l = e.rotate, c = e.tabIndex, s = e.onClick, d = e.twoToneColor, E = Dn(e, ya), f = q.useContext(Tn), T = f.prefixCls, h = T === void 0 ? "anticon" : T, g = f.rootClassName, C = Gr(g, h, (t = {}, gt(t, "".concat(h, "-").concat(i.name), !!i.name), gt(t, "".concat(h, "-spin"), !!o || i.name === "loading"), t), a), x = c;
  x === void 0 && s && (x = -1);
  var S = l ? {
    msTransform: "rotate(".concat(l, "deg)"),
    transform: "rotate(".concat(l, "deg)")
  } : void 0, k = wn(d), F = yn(k, 2), I = F[0], P = F[1];
  return /* @__PURE__ */ q.createElement("span", _(_({
    role: "img",
    "aria-label": i.name
  }, E), {}, {
    ref: n,
    tabIndex: x,
    onClick: s,
    className: C
  }), /* @__PURE__ */ q.createElement(It, {
    icon: i,
    primaryColor: I,
    secondaryColor: P,
    style: S
  }));
});
Ze.displayName = "AntdIcon";
Ze.getTwoToneColor = Ta;
Ze.setTwoToneColor = In;
const pe = Ze;
var Da = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z" } }] }, name: "close", theme: "outlined" };
const Na = Da;
var Un = function(n, t) {
  return /* @__PURE__ */ q.createElement(pe, _(_({}, n), {}, {
    ref: t,
    icon: Na
  }));
};
Un.displayName = "CloseOutlined";
const bn = /* @__PURE__ */ q.forwardRef(Un);
var Ba = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z" } }] }, name: "exclamation-circle", theme: "outlined" };
const xa = Ba;
var Rn = function(n, t) {
  return /* @__PURE__ */ q.createElement(pe, _(_({}, n), {}, {
    ref: t,
    icon: xa
  }));
};
Rn.displayName = "ExclamationCircleOutlined";
const La = /* @__PURE__ */ q.forwardRef(Rn);
var Ma = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, name: "left", theme: "outlined" };
const va = Ma;
var kn = function(n, t) {
  return /* @__PURE__ */ q.createElement(pe, _(_({}, n), {}, {
    ref: t,
    icon: va
  }));
};
kn.displayName = "LeftOutlined";
const Fa = /* @__PURE__ */ q.forwardRef(kn);
var wa = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, name: "loading", theme: "outlined" };
const Ia = wa;
var Kn = function(n, t) {
  return /* @__PURE__ */ q.createElement(pe, _(_({}, n), {}, {
    ref: t,
    icon: Ia
  }));
};
Kn.displayName = "LoadingOutlined";
const On = /* @__PURE__ */ q.forwardRef(Kn);
var Ua = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "defs", attrs: {}, children: [{ tag: "style", attrs: {} }] }, { tag: "path", attrs: { d: "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z" } }, { tag: "path", attrs: { d: "M176 474h672q8 0 8 8v60q0 8-8 8H176q-8 0-8-8v-60q0-8 8-8z" } }] }, name: "plus", theme: "outlined" };
const ba = Ua;
var Pn = function(n, t) {
  return /* @__PURE__ */ q.createElement(pe, _(_({}, n), {}, {
    ref: t,
    icon: ba
  }));
};
Pn.displayName = "PlusOutlined";
const Je = /* @__PURE__ */ q.forwardRef(Pn);
var Ra = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, name: "right", theme: "outlined" };
const ka = Ra;
var Hn = function(n, t) {
  return /* @__PURE__ */ q.createElement(pe, _(_({}, n), {}, {
    ref: t,
    icon: ka
  }));
};
Hn.displayName = "RightOutlined";
const Yn = /* @__PURE__ */ q.forwardRef(Hn);
var Ka = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] }, name: "search", theme: "outlined" };
const Oa = Ka;
var Gn = function(n, t) {
  return /* @__PURE__ */ q.createElement(pe, _(_({}, n), {}, {
    ref: t,
    icon: Oa
  }));
};
Gn.displayName = "SearchOutlined";
const Pa = /* @__PURE__ */ q.forwardRef(Gn), Ha = m(un)`
  width: ${(e) => e.$width || "100%"};
  height: ${(e) => e.$height || "40px"};
  ${z.MarginControl}
`, Ya = { ContainerButton: Ha }, le = (e) => /* @__PURE__ */ r.createElement(Ya.ContainerButton, N({}, e)), Ga = m(le)`
  background-color: ${j.NEUTRAL_10};
  color: ${j.NEUTRAL_100};
  box-shadow: none;

  :hover {
    transition: background-color 0.3s;
    color: ${j.NEUTRAL_100} !important;
    background-color: ${j.NEUTRAL_20} !important;
  }
`, Va = m.div`
  width: 270px;
`, Qa = m.div`
  margin-left: 8px;
`, ot = { Button: Ga, Container: Va, PopconfirmTitle: Qa }, Vn = (n) => {
  var e = X(n, []);
  return /* @__PURE__ */ r.createElement(de.SVG, N({ xmlns: "http://www.w3.org/2000/svg", width: "18", height: "15", viewBox: "0 0 18 15", fill: "none" }, e), /* @__PURE__ */ r.createElement(
    "path",
    {
      d: "M9 3.4925L14.6475 13.25H3.3525L9 3.4925ZM9 0.5L0.75 14.75H17.25L9 0.5ZM9.75 11H8.25V12.5H9.75V11ZM9.75 6.5H8.25V9.5H9.75V6.5Z",
      fill: "#E99921"
    }
  ));
}, Ja = ({ translation: e, onEndSeasonConfirm: n }) => /* @__PURE__ */ r.createElement(ot.Container, null, /* @__PURE__ */ r.createElement(
  fn,
  {
    icon: /* @__PURE__ */ r.createElement(Vn, { width: "24", height: "24" }),
    title: /* @__PURE__ */ r.createElement(ot.PopconfirmTitle, null, /* @__PURE__ */ r.createElement(R.Description, null, e.endSeasonPopconfirmTitle), /* @__PURE__ */ r.createElement(R.Description, null, e.endSeasonPopConfirmCTAText)),
    okText: e.endSeasonPopconfirmOkText,
    cancelText: e.endSeasonPopconfirmCancelText,
    onConfirm: n,
    cancelButtonProps: {
      style: {
        backgroundColor: j.NEUTRAL_10,
        border: `1px solid ${j.NEUTRAL_10}`,
        borderRadius: "4px",
        height: "32px",
        color: j.NEUTRAL_100
      }
    },
    okButtonProps: {
      style: {
        backgroundColor: j.GREEN_60,
        borderRadius: "4px",
        height: "32px",
        color: j.WHITE,
        border: "none",
        boxShadow: "none"
      }
    }
  },
  /* @__PURE__ */ r.createElement(ot.Button, { "data-testid": An.SETUP_FORM_END_SEASON_BUTTON, $width: "270px", type: "primary" }, /* @__PURE__ */ r.createElement(R.Title, { $fontSize: "14px", $fontWeight: "400" }, e.endSeasonButton, " ", /* @__PURE__ */ r.createElement(Yn, null)))
)), Qn = ({
  translation: e,
  translationPopconfirm: n,
  translationEndSeasonButton: t,
  onBackConfirm: a,
  showHeaderSteps: i,
  steps: o,
  currentPage: l,
  setCurrentPage: c,
  customHeader: s,
  maxLengthStepName: d,
  showEndSeasonButton: E = !1,
  onEndSeasonConfirm: f
}) => /* @__PURE__ */ r.createElement(We.ContainerHeader, { "data-testid": dt.HEADER_CONTAINER }, /* @__PURE__ */ r.createElement(v.Flex, null, /* @__PURE__ */ r.createElement(Ft, { translation: n, onBackConfirm: a }, /* @__PURE__ */ r.createElement(mt, { $cursor: "pointer" })), /* @__PURE__ */ r.createElement(We.ContainerTitle, null, /* @__PURE__ */ r.createElement(R.Title, { $marginLeft: "12px", $fontSize: "20px" }, e.headerTitlePage))), i && !!(o != null && o.length) && /* @__PURE__ */ r.createElement(We.ContainerSteps, null, /* @__PURE__ */ r.createElement(
  mr,
  {
    size: "small",
    "data-testid": dt.HEADER_STEPS,
    items: Mr(o, l, c, d),
    current: l
  }
)), E && /* @__PURE__ */ r.createElement(Ja, { translation: t, onEndSeasonConfirm: f }), s), _a = m(v.FlexJustifyBetween)`
  padding-top: 28px;
  padding-bottom: 24px;
  justify-content: center;
`, za = { Container: _a }, ja = r.memo(
  ({
    isShowExitButton: e,
    isFirstPage: n,
    translationPopconfirm: t,
    textPreviousButton: a,
    disabledNext: i,
    textNextButton: o,
    onBack: l,
    onClickPrevious: c,
    onClickNext: s,
    stepLoading: d
  }) => /* @__PURE__ */ r.createElement(za.Container, null, e && /* @__PURE__ */ r.createElement(Ft, { translation: t, disabled: !n, onBackConfirm: l }, /* @__PURE__ */ r.createElement(
    le,
    {
      "data-testid": Te.SETUP_FORM_STEP_PREVIOUS_BUTTON,
      $marginRight: "8px",
      onClick: n ? () => null : c
    },
    a
  )), /* @__PURE__ */ r.createElement(
    le,
    {
      "data-testid": Te.SETUP_FORM_STEP_NEXT_BUTTON,
      $marginLeft: "8px",
      type: "primary",
      disabled: i,
      onClick: s,
      loading: d,
      style: { width: !e && "380px" }
    },
    o
  ))
), Za = m(v.FlexColumn)`
  width: 100%;
  max-width: 680px;

  justify-content: space-between;
`, qa = m(v.Flex)`
  align-items: end;
`, Wa = m.div`
  width: 100%;
  overflow-y: auto;
  height: calc(100vh - 324px);
`, it = { Container: Za, ContainerTitle: qa, ContainerChildren: Wa }, Xa = ({
  currentPage: e,
  totalEnabledPages: n,
  title: t,
  subTitle: a,
  onBack: i,
  onClickNext: o,
  onClickPrevious: l,
  children: c,
  translation: s,
  disabledNext: d,
  icon: E,
  stepLoading: f
}) => {
  var S, k;
  const T = e === 0, h = e === n - 1, g = !(T && !((S = s == null ? void 0 : s.step) != null && S.stepExitButton)), C = T ? (k = s == null ? void 0 : s.step) == null ? void 0 : k.stepExitButton : s.step.stepPreviousButton, x = h ? s.step.stepConclusionButton : s.step.stepNextButton;
  return /* @__PURE__ */ r.createElement(it.Container, { "data-testid": Te.SETUP_FORM_STEP_CONTAINER }, /* @__PURE__ */ r.createElement("div", null, t && /* @__PURE__ */ r.createElement(it.ContainerTitle, null, E, /* @__PURE__ */ r.createElement(R.Title, { "data-testid": Te.SETUP_FORM_STEP_TITLE }, t)), a && /* @__PURE__ */ r.createElement(
    R.Description,
    {
      $color: "#696f88",
      $marginTop: "8px",
      $marginBottom: "24px",
      "data-testid": Te.SETUP_FORM_STEP_SUB_TITLE
    },
    a
  ), /* @__PURE__ */ r.createElement(it.ContainerChildren, null, c)), /* @__PURE__ */ r.createElement(
    ja,
    {
      isShowExitButton: g,
      isFirstPage: T,
      translationPopconfirm: s.backPopConfirm,
      textPreviousButton: C,
      textNextButton: x,
      disabledNext: d,
      onBack: i,
      onClickNext: o,
      onClickPrevious: l,
      stepLoading: f
    }
  ));
}, $a = (e, n, t, a, i, o) => {
  const [l, c] = J(!0), [s, d] = J(0), E = i >= 0 && o ? i : s, f = i >= 0 && o ? o : d, T = ne(() => e.filter((C) => !!C.enabled), [e]);
  return {
    filteredSteps: T,
    currentPage: E,
    disabledNext: l,
    setDisabledNext: c,
    handleNextPage: () => {
      var x;
      t && t(((x = T[E]) == null ? void 0 : x.id) || "");
      const C = E + 1;
      C < T.length && f(C);
    },
    handlePreviousPage: () => {
      var C;
      a && a(((C = T[E]) == null ? void 0 : C.id) || ""), E > 0 ? f(E - 1) : n();
    },
    setCurrentPage: f
  };
}, eo = m(v.FlexColumn)`
  height: 100%;
`, to = m(v.FlexJustifyCenter)`
  flex: 1;
  padding-top: 12px;
`, no = m(v.FlexCenter)`
  height: calc(100vh - 92px);
`, lt = { Container: eo, StepContainer: to, ContainerFull: no }, ro = ({
  steps: e,
  translations: n,
  disabledNext: t = !1,
  onBack: a,
  callbackNext: i,
  callbackPrevious: o,
  currentPageProps: l,
  setCurrentPageProps: c,
  startLoading: s,
  stepLoading: d,
  showHeaderSteps: E,
  maxLengthStepName: f = 16,
  onEndSeasonConfirm: T,
  showEndSeasonButton: h
}) => {
  const { currentPage: g, handleNextPage: C, handlePreviousPage: x, filteredSteps: S, setCurrentPage: k } = $a(
    e,
    a,
    i,
    o,
    l,
    c
  ), F = S == null ? void 0 : S.length;
  return /* @__PURE__ */ r.createElement(ze, null, /* @__PURE__ */ r.createElement(lt.Container, { "data-testid": Et.SETUP_FORM_CONTAINER }, /* @__PURE__ */ r.createElement(
    Qn,
    {
      translation: n.header,
      translationPopconfirm: n.backPopConfirm,
      onBackConfirm: a,
      showHeaderSteps: E,
      steps: S,
      currentPage: g,
      setCurrentPage: k,
      maxLengthStepName: f,
      showEndSeasonButton: h,
      onEndSeasonConfirm: T,
      translationEndSeasonButton: n.endSeasonButton
    }
  ), s ? /* @__PURE__ */ r.createElement(lt.ContainerFull, { "data-testid": Et.SETUP_FORM_LOADING }, /* @__PURE__ */ r.createElement(vt, { size: "large" })) : /* @__PURE__ */ r.createElement(lt.StepContainer, null, S[g] && /* @__PURE__ */ r.createElement(
    Xa,
    {
      key: S[g].id,
      currentPage: g,
      totalEnabledPages: F,
      title: S[g].title,
      subTitle: S[g].subTitle,
      icon: S[g].icon,
      translation: n,
      disabledNext: t,
      onBack: a,
      onClickPrevious: x,
      onClickNext: C,
      stepLoading: d
    },
    S[g].reactNode
  ))));
};
var Tt = {}, ao = {
  get exports() {
    return Tt;
  },
  set exports(e) {
    Tt = e;
  }
};
(function(e, n) {
  (function(t, a) {
    e.exports = a();
  })(Nn, function() {
    var t = 1e3, a = 6e4, i = 36e5, o = "millisecond", l = "second", c = "minute", s = "hour", d = "day", E = "week", f = "month", T = "quarter", h = "year", g = "date", C = "Invalid Date", x = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, S = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, k = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(B) {
      var p = ["th", "st", "nd", "rd"], A = B % 100;
      return "[" + B + (p[(A - 20) % 10] || p[A] || p[0]) + "]";
    } }, F = function(B, p, A) {
      var M = String(B);
      return !M || M.length >= p ? B : "" + Array(p + 1 - M.length).join(A) + B;
    }, I = { s: F, z: function(B) {
      var p = -B.utcOffset(), A = Math.abs(p), M = Math.floor(A / 60), u = A % 60;
      return (p <= 0 ? "+" : "-") + F(M, 2, "0") + ":" + F(u, 2, "0");
    }, m: function B(p, A) {
      if (p.date() < A.date())
        return -B(A, p);
      var M = 12 * (A.year() - p.year()) + (A.month() - p.month()), u = p.clone().add(M, f), y = A - u < 0, D = p.clone().add(M + (y ? -1 : 1), f);
      return +(-(M + (A - u) / (y ? u - D : D - u)) || 0);
    }, a: function(B) {
      return B < 0 ? Math.ceil(B) || 0 : Math.floor(B);
    }, p: function(B) {
      return { M: f, y: h, w: E, d, D: g, h: s, m: c, s: l, ms: o, Q: T }[B] || String(B || "").toLowerCase().replace(/s$/, "");
    }, u: function(B) {
      return B === void 0;
    } }, P = "en", K = {};
    K[P] = k;
    var V = function(B) {
      return B instanceof te;
    }, W = function B(p, A, M) {
      var u;
      if (!p)
        return P;
      if (typeof p == "string") {
        var y = p.toLowerCase();
        K[y] && (u = y), A && (K[y] = A, u = y);
        var D = p.split("-");
        if (!u && D.length > 1)
          return B(D[0]);
      } else {
        var O = p.name;
        K[O] = p, u = O;
      }
      return !M && u && (P = u), u || !M && P;
    }, b = function(B, p) {
      if (V(B))
        return B.clone();
      var A = typeof p == "object" ? p : {};
      return A.date = B, A.args = arguments, new te(A);
    }, L = I;
    L.l = W, L.i = V, L.w = function(B, p) {
      return b(B, { locale: p.$L, utc: p.$u, x: p.$x, $offset: p.$offset });
    };
    var te = function() {
      function B(A) {
        this.$L = W(A.locale, null, !0), this.parse(A);
      }
      var p = B.prototype;
      return p.parse = function(A) {
        this.$d = function(M) {
          var u = M.date, y = M.utc;
          if (u === null)
            return /* @__PURE__ */ new Date(NaN);
          if (L.u(u))
            return /* @__PURE__ */ new Date();
          if (u instanceof Date)
            return new Date(u);
          if (typeof u == "string" && !/Z$/i.test(u)) {
            var D = u.match(x);
            if (D) {
              var O = D[2] - 1 || 0, Q = (D[7] || "0").substring(0, 3);
              return y ? new Date(Date.UTC(D[1], O, D[3] || 1, D[4] || 0, D[5] || 0, D[6] || 0, Q)) : new Date(D[1], O, D[3] || 1, D[4] || 0, D[5] || 0, D[6] || 0, Q);
            }
          }
          return new Date(u);
        }(A), this.$x = A.x || {}, this.init();
      }, p.init = function() {
        var A = this.$d;
        this.$y = A.getFullYear(), this.$M = A.getMonth(), this.$D = A.getDate(), this.$W = A.getDay(), this.$H = A.getHours(), this.$m = A.getMinutes(), this.$s = A.getSeconds(), this.$ms = A.getMilliseconds();
      }, p.$utils = function() {
        return L;
      }, p.isValid = function() {
        return this.$d.toString() !== C;
      }, p.isSame = function(A, M) {
        var u = b(A);
        return this.startOf(M) <= u && u <= this.endOf(M);
      }, p.isAfter = function(A, M) {
        return b(A) < this.startOf(M);
      }, p.isBefore = function(A, M) {
        return this.endOf(M) < b(A);
      }, p.$g = function(A, M, u) {
        return L.u(A) ? this[M] : this.set(u, A);
      }, p.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, p.valueOf = function() {
        return this.$d.getTime();
      }, p.startOf = function(A, M) {
        var u = this, y = !!L.u(M) || M, D = L.p(A), O = function(Se, $) {
          var me = L.w(u.$u ? Date.UTC(u.$y, $, Se) : new Date(u.$y, $, Se), u);
          return y ? me : me.endOf(d);
        }, Q = function(Se, $) {
          return L.w(u.toDate()[Se].apply(u.toDate("s"), (y ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice($)), u);
        }, H = this.$W, Z = this.$M, oe = this.$D, Ee = "set" + (this.$u ? "UTC" : "");
        switch (D) {
          case h:
            return y ? O(1, 0) : O(31, 11);
          case f:
            return y ? O(1, Z) : O(0, Z + 1);
          case E:
            var Ne = this.$locale().weekStart || 0, Be = (H < Ne ? H + 7 : H) - Ne;
            return O(y ? oe - Be : oe + (6 - Be), Z);
          case d:
          case g:
            return Q(Ee + "Hours", 0);
          case s:
            return Q(Ee + "Minutes", 1);
          case c:
            return Q(Ee + "Seconds", 2);
          case l:
            return Q(Ee + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, p.endOf = function(A) {
        return this.startOf(A, !1);
      }, p.$set = function(A, M) {
        var u, y = L.p(A), D = "set" + (this.$u ? "UTC" : ""), O = (u = {}, u[d] = D + "Date", u[g] = D + "Date", u[f] = D + "Month", u[h] = D + "FullYear", u[s] = D + "Hours", u[c] = D + "Minutes", u[l] = D + "Seconds", u[o] = D + "Milliseconds", u)[y], Q = y === d ? this.$D + (M - this.$W) : M;
        if (y === f || y === h) {
          var H = this.clone().set(g, 1);
          H.$d[O](Q), H.init(), this.$d = H.set(g, Math.min(this.$D, H.daysInMonth())).$d;
        } else
          O && this.$d[O](Q);
        return this.init(), this;
      }, p.set = function(A, M) {
        return this.clone().$set(A, M);
      }, p.get = function(A) {
        return this[L.p(A)]();
      }, p.add = function(A, M) {
        var u, y = this;
        A = Number(A);
        var D = L.p(M), O = function(Z) {
          var oe = b(y);
          return L.w(oe.date(oe.date() + Math.round(Z * A)), y);
        };
        if (D === f)
          return this.set(f, this.$M + A);
        if (D === h)
          return this.set(h, this.$y + A);
        if (D === d)
          return O(1);
        if (D === E)
          return O(7);
        var Q = (u = {}, u[c] = a, u[s] = i, u[l] = t, u)[D] || 1, H = this.$d.getTime() + A * Q;
        return L.w(H, this);
      }, p.subtract = function(A, M) {
        return this.add(-1 * A, M);
      }, p.format = function(A) {
        var M = this, u = this.$locale();
        if (!this.isValid())
          return u.invalidDate || C;
        var y = A || "YYYY-MM-DDTHH:mm:ssZ", D = L.z(this), O = this.$H, Q = this.$m, H = this.$M, Z = u.weekdays, oe = u.months, Ee = function($, me, qe, be) {
          return $ && ($[me] || $(M, y)) || qe[me].slice(0, be);
        }, Ne = function($) {
          return L.s(O % 12 || 12, $, "0");
        }, Be = u.meridiem || function($, me, qe) {
          var be = $ < 12 ? "AM" : "PM";
          return qe ? be.toLowerCase() : be;
        }, Se = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: H + 1, MM: L.s(H + 1, 2, "0"), MMM: Ee(u.monthsShort, H, oe, 3), MMMM: Ee(oe, H), D: this.$D, DD: L.s(this.$D, 2, "0"), d: String(this.$W), dd: Ee(u.weekdaysMin, this.$W, Z, 2), ddd: Ee(u.weekdaysShort, this.$W, Z, 3), dddd: Z[this.$W], H: String(O), HH: L.s(O, 2, "0"), h: Ne(1), hh: Ne(2), a: Be(O, Q, !0), A: Be(O, Q, !1), m: String(Q), mm: L.s(Q, 2, "0"), s: String(this.$s), ss: L.s(this.$s, 2, "0"), SSS: L.s(this.$ms, 3, "0"), Z: D };
        return y.replace(S, function($, me) {
          return me || Se[$] || D.replace(":", "");
        });
      }, p.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, p.diff = function(A, M, u) {
        var y, D = L.p(M), O = b(A), Q = (O.utcOffset() - this.utcOffset()) * a, H = this - O, Z = L.m(this, O);
        return Z = (y = {}, y[h] = Z / 12, y[f] = Z, y[T] = Z / 3, y[E] = (H - Q) / 6048e5, y[d] = (H - Q) / 864e5, y[s] = H / i, y[c] = H / a, y[l] = H / t, y)[D] || H, u ? Z : L.a(Z);
      }, p.daysInMonth = function() {
        return this.endOf(f).$D;
      }, p.$locale = function() {
        return K[this.$L];
      }, p.locale = function(A, M) {
        if (!A)
          return this.$L;
        var u = this.clone(), y = W(A, M, !0);
        return y && (u.$L = y), u;
      }, p.clone = function() {
        return L.w(this.$d, this);
      }, p.toDate = function() {
        return new Date(this.valueOf());
      }, p.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, p.toISOString = function() {
        return this.$d.toISOString();
      }, p.toString = function() {
        return this.$d.toUTCString();
      }, B;
    }(), ce = te.prototype;
    return b.prototype = ce, [["$ms", o], ["$s", l], ["$m", c], ["$H", s], ["$W", d], ["$M", f], ["$y", h], ["$D", g]].forEach(function(B) {
      ce[B[1]] = function(p) {
        return this.$g(p, B[0], B[1]);
      };
    }), b.extend = function(B, p) {
      return B.$i || (B(p, te, b), B.$i = !0), b;
    }, b.locale = W, b.isDayjs = V, b.unix = function(B) {
      return b(1e3 * B);
    }, b.en = K[P], b.Ls = K, b.p = {}, b;
  });
})(ao);
const U = Tt;
var G = /* @__PURE__ */ ((e) => (e.SOYBEAN = "SOYBEAN", e.OTHER = "OTHER", e.CORN = "CORN", e.SORGHUM = "SORGHUM", e.COTTON = "COTTON", e.WHEAT = "WHEAT", e.WINTER_WHEAT = "WINTER_WHEAT", e))(G || {}), yt = {}, oo = {
  get exports() {
    return yt;
  },
  set exports(e) {
    yt = e;
  }
};
(function(e, n) {
  (function(t, a) {
    e.exports = a();
  })(Nn, function() {
    return function(t, a, i) {
      a.prototype.isBetween = function(o, l, c, s) {
        var d = i(o), E = i(l), f = (s = s || "()")[0] === "(", T = s[1] === ")";
        return (f ? this.isAfter(d, c) : !this.isBefore(d, c)) && (T ? this.isBefore(E, c) : !this.isAfter(E, c)) || (f ? this.isBefore(d, c) : !this.isAfter(d, c)) && (T ? this.isAfter(E, c) : !this.isBefore(E, c));
      };
    };
  });
})(oo);
const io = yt;
U.extend(io);
const lo = {
  soybean: G.SOYBEAN,
  corn: G.CORN,
  sorghum: G.SORGHUM,
  cotton: G.COTTON,
  winter_wheat: G.WINTER_WHEAT
}, co = (e, n) => `${Number(e) - 1}/${e.substring(2)} ${n} ${e}`, so = (e) => Array(e).fill(Number(U().format("YYYY")) + 1).reduce((n, t, a) => Y(N({}, n), { [t - a]: void 0 }), {}), Eo = (e, n) => U(n).format("YYYY") === e, fo = (e, n) => (e == null ? void 0 : e.crop_type) === (n == null ? void 0 : n.crop_type) && (e == null ? void 0 : e.year) === (n == null ? void 0 : n.year), uo = (e, n, t, a) => {
  if (!e || !n || !t || !a)
    return !1;
  const i = U(e), o = U(n), l = U(t), c = U(a);
  return i.isBetween(l, c, null, "[]") || o.isBetween(l, c, null, "[]") || l.isBetween(i, o, null, "[]") || c.isBetween(i, o, null, "[]");
}, en = (e, n, t) => {
  const a = so(e);
  return t ? Object.keys(a).reduce((i, o) => {
    var c;
    const l = (c = t.aois[0]) == null ? void 0 : c.crops;
    if (l && l.length > 0) {
      const s = l.find((d) => d.crop_type === n && Eo(o, d.end_date));
      if (s)
        return Y(N({}, i), {
          [o]: {
            startDate: U(s.start_date),
            endDate: U(s.end_date)
          }
        });
    }
    return Y(N({}, i), {
      [o]: void 0
    });
  }, {}) : a;
}, tn = (e, n) => e ? Object.keys(e).reduce((t, a) => {
  var i, o, l, c, s;
  return (i = e[a]) != null && i.startDate && ((o = e[a]) != null && o.endDate) && t.push({
    crop_type: n,
    start_date: (l = e[a]) == null ? void 0 : l.startDate.format("YYYY-MM-DD"),
    end_date: (c = e[a]) == null ? void 0 : c.endDate.format("YYYY-MM-DD"),
    year: (s = e[a]) == null ? void 0 : s.endDate.format("YYYY")
  }), t;
}, []) : [], ho = (e) => Array.from({ length: 6 }, (n, t) => (Number(e) - t).toString()), mo = (e, n) => {
  const t = n.find(
    (i) => {
      var o;
      return (o = i == null ? void 0 : i.crop_identified) == null ? void 0 : o.toLowerCase().includes("soybean");
    }
  ), a = n.some((i) => {
    var o;
    return (o = i == null ? void 0 : i.crop_identified) == null ? void 0 : o.toLowerCase().includes("soybean");
  });
  return [{
    crop_type: G.SOYBEAN,
    start_date: a ? t == null ? void 0 : t.start_date : void 0,
    end_date: a ? t == null ? void 0 : t.end_date : void 0,
    year: e
  }];
}, go = (e) => [
  {
    crop_type: G.SOYBEAN,
    start_date: void 0,
    end_date: void 0,
    year: e
  },
  {
    crop_type: G.OTHER,
    start_date: void 0,
    end_date: void 0,
    year: e
  }
], Co = (e, n) => e.map((a) => {
  var l, c;
  const i = (l = a == null ? void 0 : a.crop_identified) == null ? void 0 : l.toLowerCase();
  return {
    crop_type: (i == null ? void 0 : i.includes("soybean")) ? G.SOYBEAN : (c = lo[i]) != null ? c : G.OTHER,
    start_date: a == null ? void 0 : a.start_date,
    end_date: a == null ? void 0 : a.end_date,
    year: n
  };
}), Ao = (e, n, t) => {
  var l, c, s, d;
  const a = (c = (l = n == null ? void 0 : n.data) == null ? void 0 : l.crop_cycles_identified) != null ? c : {}, i = U().format("YYYY"), o = t.reduce((E, f) => {
    var h;
    const T = (h = a == null ? void 0 : a[f]) != null ? h : [];
    return f === i ? [...E, ...mo(f, T)] : !Array.isArray(T) || T.length === 0 ? [...E, ...go(f)] : [...E, ...Co(T, f)];
  }, []).sort((E, f) => Number(f.year) - Number(E.year));
  return {
    aoi_id: e,
    crops: o,
    isLoading: (s = n == null ? void 0 : n.isLoading) != null ? s : !1,
    hasError: (d = n == null ? void 0 : n.isError) != null ? d : !1
  };
}, po = (e, n, t, a, i, o, l) => {
  const c = !!i && !!o, s = U().format("YYYY"), d = ho(s), E = l == null ? void 0 : l.map(
    ({ fieldId: f, query: T }) => Ao(f, T, d)
  );
  return {
    contract_id: c ? i == null ? void 0 : i.contract_id : a,
    crop_cycle_end: c ? i == null ? void 0 : i.crop_cycle_end : n,
    crop_cycle_start: c ? i == null ? void 0 : i.crop_cycle_start : e,
    workspace_id: c ? i == null ? void 0 : i.workspace_id : t,
    aois: E
  };
}, So = (e, n, t, a, i, o, l) => {
  var d;
  const c = !!o && !!l, s = (d = e == null ? void 0 : e.fieldsSelected) == null ? void 0 : d.map((E) => {
    var h, g;
    const f = (g = (h = o == null ? void 0 : o.aois) == null ? void 0 : h.find((C) => C.aoi_id === E.id)) == null ? void 0 : g.crops, T = f && f.length > 0 && c;
    return {
      aoi_id: E.id,
      crops: T ? f : tn(e.soyYearsWithRange, G.SOYBEAN).concat(tn(e.othersYearsWithRange, G.OTHER))
    };
  });
  return {
    contract_id: c ? o == null ? void 0 : o.contract_id : i,
    crop_cycle_end: c ? o == null ? void 0 : o.crop_cycle_end : t,
    crop_cycle_start: c ? o == null ? void 0 : o.crop_cycle_start : n,
    workspace_id: c ? o == null ? void 0 : o.workspace_id : a,
    aois: s
  };
}, To = (e, n, t) => {
  let a = !1;
  return !(Object.keys(e).reduce((o, l) => (e[l] && ((!e[l].endDate || !e[l].startDate || e[l].endDate.diff(e[l].startDate) <= 0 || e[l].endDate.diff(e[l].startDate, "months") > t) && (a = !0), o.push(e[l])), o), []).length >= n && !a);
}, yo = (e, n) => U(`${Number(e)}-${n}-01`), Jn = (e, n) => U(`${Number(e)}-${n}-01`).endOf("month"), Dt = (e, n) => n === "startDate" ? e == null ? void 0 : e.startOf("month") : e == null ? void 0 : e.endOf("month"), Pe = (e) => U(e).toDate().getTime(), Do = (e) => {
  let n = !1;
  return e.forEach((t, a) => {
    e.forEach((i, o) => {
      if (a !== o) {
        const l = Pe(t.start_date), c = Pe(t.end_date), s = Pe(i.start_date), d = Pe(i.end_date);
        (l > s && l < d || s > l && s < c || c > s && c < d || d > l && d < c) && (n = !0);
      }
    });
  }), n;
}, No = (e) => {
  let n = !1;
  return e.aois.forEach((t) => {
    Do(t.crops.filter((a) => !!a && !!a.crop_type && !!a.start_date && !!a.end_date)) && (n = !0);
  }), n;
}, Bo = (e, n, t, a, i, o, l, c, s, d) => {
  const [E, f] = J(!0), [T, h] = J(!0), [g, C] = J(!1), [x, S] = J(0), [k, F] = J(), [I, P] = J({
    fieldsSelected: n.selectFieldNemadigital ? [] : [...t],
    soyYearsWithRange: en(e, G.SOYBEAN, a),
    othersYearsWithRange: en(e, G.OTHER, a)
  });
  return re(() => {
    if (d) {
      const L = s != null && s.length ? po(
        i,
        o,
        l,
        c,
        a,
        E,
        s
      ) : void 0;
      F(L), f(!1);
      return;
    }
    const b = So(I, i, o, l, c, a, E);
    F(b), f(!1);
  }, [I, i, o, l, c, s, a, E, d]), {
    disabledNext: T,
    nemaConfigData: I,
    currentPage: x,
    showEditFieldCrop: g,
    newRequestCreateJob: k,
    setEditFieldCrop: C,
    setCurrentPage: S,
    handleOnChangeFieldsSelect: (b) => {
      P((L) => Y(N({}, L), {
        fieldsSelected: b
      }));
    },
    handleOnChangeSoyYears: (b) => {
      P((L) => Y(N({}, L), {
        soyYearsWithRange: b
      }));
    },
    handleOnChangeOthersYears: (b) => {
      P((L) => Y(N({}, L), {
        othersYearsWithRange: b
      }));
    },
    setDisabledNext: h,
    setNewRequestCreateJob: F
  };
}, Ut = (t) => {
  var a = t, { $size: e = "32" } = a, n = X(a, ["$size"]);
  return /* @__PURE__ */ r.createElement(de.SVG, N({ width: e, height: e, viewBox: "0 0 32 32", fill: "none" }, n), /* @__PURE__ */ r.createElement("rect", { width: e, height: e, rx: "4", fill: "#FFF3DD" }), /* @__PURE__ */ r.createElement(
    "path",
    {
      d: "M16 23.3404C15.7786 23.3404 15.4096 23.3206 15.2944 23.2846L15.2908 23.2828C15.0424 23.2162 14.8768 23.0074 14.8768 22.7644C14.8768 22.7212 14.8822 22.6744 14.893 22.6366L14.9146 22.5502L14.83 22.5268C14.4502 22.4242 14.1046 22.2172 13.8022 21.9094C13.3342 21.4306 12.9778 20.734 12.7132 19.7818C12.2434 18.133 11.9338 17.5678 11.5144 16.8964C11.374 16.6732 11.257 16.5058 11.1634 16.3726C10.951 16.0684 10.8628 15.9424 10.8628 15.703C10.8628 15.5158 10.9402 15.3394 11.0824 15.2062C11.2318 15.0658 11.4424 14.9884 11.6746 14.9884C11.8906 14.9884 12.3316 15.0568 12.9202 15.2476L13.0318 15.2836L13.039 15.1666C13.1344 13.471 13.4674 11.887 13.975 10.7062C14.2396 10.0888 14.5438 9.6082 14.8768 9.277C15.2242 8.9296 15.5986 8.7532 15.9892 8.7532C16.3798 8.7532 16.7542 8.9296 17.1016 9.277C17.4346 9.6082 17.737 10.0906 18.0034 10.7062C18.511 11.887 18.844 13.4728 18.9394 15.172L18.9466 15.289L19.0582 15.2512C19.5568 15.0856 19.9798 14.9974 20.2858 14.9974C20.5648 14.9974 20.7916 15.0694 20.9446 15.2044C21.0796 15.3232 21.1516 15.487 21.1516 15.676C21.1516 15.91 21.0346 16.0756 20.824 16.3762C20.7178 16.5274 20.5864 16.7128 20.4388 16.9558C19.7872 17.998 19.5622 18.772 19.2778 19.7512L19.2652 19.7926C18.9718 20.8096 18.6244 21.4918 18.1708 21.9382C17.8774 22.2244 17.5516 22.4134 17.1718 22.516L17.089 22.5376L17.107 22.6222C17.1178 22.669 17.1232 22.7158 17.1232 22.759C17.1232 23.0146 16.9612 23.2234 16.7092 23.29L16.7056 23.2918C16.6156 23.3188 16.216 23.3404 16 23.3404ZM12.517 16.4392C13.1506 17.485 13.462 18.3472 13.786 19.483C14.1784 20.8708 14.7076 21.5458 15.4042 21.5458C15.6598 21.5458 16.2574 21.445 16.2574 20.5198C16.2574 19.9474 15.9856 18.9538 15.2206 18.0376C14.7652 17.4904 13.9444 16.747 12.6214 16.306L12.3892 16.2286L12.517 16.4392ZM19.348 16.3078C18.043 16.7272 17.1448 17.44 16.621 17.962L16.5706 18.0124L16.6066 18.0736C17.1628 18.988 17.4238 20.0104 17.3446 20.9536L17.3194 21.2506L17.5048 21.0166C17.7694 20.6836 17.9926 20.1832 18.187 19.4848C18.4642 18.5092 18.7504 17.6056 19.4506 16.441L19.5748 16.2358L19.348 16.3078ZM14.308 13.7284C14.2162 14.3674 14.1622 15.0388 14.1514 15.7192L14.1496 15.7732L14.1982 15.7984C14.857 16.1548 15.406 16.5724 15.8326 17.0404L15.8956 17.1088L15.9622 17.044C16.4122 16.6102 17.0368 16.18 17.7676 15.7984L17.8162 15.7732V15.7192C17.8162 15.4816 17.8054 15.2188 17.7856 14.938L17.7802 14.8552H16.864V13.9372H17.6812L17.6668 13.8346C17.6254 13.5286 17.5768 13.2298 17.521 12.9472L17.5066 12.8734H16.522V11.9554H17.2852L17.251 11.8402C17.08 11.257 16.8784 10.7692 16.6678 10.4272C16.4392 10.0546 16.207 9.8674 15.982 9.8674C15.7426 9.8674 15.4888 10.0888 15.2494 10.5064L15.172 10.6414H15.91V11.4334H14.8426L14.821 11.4946C14.7094 11.815 14.6068 12.1948 14.5114 12.6214L14.488 12.7312H15.46V13.6492H14.3188L14.308 13.7284ZM14.8822 15.667V14.749H16.054V15.667H14.8822Z",
      fill: "#9A6412"
    }
  ));
}, xo = (n) => {
  var e = X(n, []);
  return /* @__PURE__ */ r.createElement(de.SVG, N({ width: "32", height: "32", viewBox: "0 0 32 32", fill: "none" }, e), /* @__PURE__ */ r.createElement("g", { clipPath: "url(#clip0_32250_216486)" }, /* @__PURE__ */ r.createElement("rect", { width: "32", height: "32", rx: "4", fill: "#EAF6FF" }), /* @__PURE__ */ r.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.255 9.2725L22.375 9.25C22.585 9.25 22.75 9.415 22.75 9.625V20.965C22.75 21.1375 22.6375 21.2725 22.48 21.325L18.25 22.75L13.75 21.175L9.745 22.7275L9.625 22.75C9.415 22.75 9.25 22.585 9.25 22.375V11.035C9.25 10.8625 9.3625 10.7275 9.52 10.675L13.75 9.25L18.25 10.825L22.255 9.2725ZM17.5 12.1516L14.5 11.1016V19.8466L17.5 20.8966V12.1516ZM10.75 11.845L13 11.0875V19.8625L10.75 20.7325V11.845ZM19 20.9125L21.25 20.155V11.275L19 12.145V20.9125Z",
      fill: "#0071CD"
    }
  )), /* @__PURE__ */ r.createElement("defs", null, /* @__PURE__ */ r.createElement("clipPath", { id: "clip0_32250_216486" }, /* @__PURE__ */ r.createElement("rect", { width: "32", height: "32", rx: "8", fill: "white" }))));
}, bt = (t) => {
  var a = t, { $size: e = "32" } = a, n = X(a, ["$size"]);
  return /* @__PURE__ */ r.createElement(de.SVG, N({ width: e, height: e, viewBox: "0 0 32 32", fill: "none" }, n), /* @__PURE__ */ r.createElement("rect", { width: e, height: e, rx: "4", fill: "#E0F9F7" }), /* @__PURE__ */ r.createElement(
    "path",
    {
      d: "M16.3528 22.5178C16.153 21.9562 16.0702 21.454 16.1008 20.9842C16.1278 20.5504 16.252 20.1544 16.4806 19.7746C16.6318 19.5136 16.9486 19.1842 17.2294 18.8926C17.5534 18.556 17.7388 18.3598 17.7658 18.2284C17.8 18.0826 17.7982 17.8036 17.7964 17.4814C17.7946 17.1718 17.791 16.8208 17.827 16.6102C17.89 16.2682 18.0538 15.9496 18.187 15.6922C18.295 15.4816 18.3742 15.3304 18.3688 15.2188C18.3688 15.1702 18.3526 15.082 18.3292 14.9524C18.2734 14.6446 18.1816 14.1316 18.2248 13.7122C18.2788 13.1938 18.4588 12.7384 18.6694 12.2128C18.9286 11.554 19.0438 11.203 18.9718 10.825C18.9034 10.465 18.6766 10.123 18.1672 9.4642L18.4966 9.1528C19.5208 10.1158 20.2156 11.0194 20.6188 11.9104C20.8762 12.4864 20.9662 13.0246 20.9176 13.7086C20.9032 13.8706 20.8744 14.083 20.8474 14.29C20.8006 14.6338 20.7574 14.9596 20.7682 15.1306C20.77 15.19 20.7862 15.2746 20.806 15.3898C20.8762 15.7714 21.0076 16.4842 20.7664 17.197C20.5486 17.8144 20.1076 18.3958 19.843 18.7432C19.744 18.8728 19.6738 18.9664 19.6378 19.0294C19.591 19.1158 19.582 19.258 19.5694 19.474C19.5496 19.8178 19.5208 20.2876 19.3156 20.7214C18.898 21.6196 17.9296 22.2064 16.3528 22.5178ZM10.7151 21.5998C10.5729 21.0616 10.5351 20.59 10.5981 20.158C10.6575 19.7566 10.8033 19.3984 11.0463 19.0636L11.0481 19.0618C11.2084 18.8296 11.536 18.5416 11.824 18.2896C12.1498 18.0052 12.3352 17.8378 12.3694 17.7226C12.409 17.5948 12.4288 17.3428 12.4504 17.0512C12.4738 16.7542 12.499 16.4176 12.5494 16.2196C12.6358 15.8992 12.8158 15.613 12.9598 15.3826C13.075 15.199 13.1578 15.064 13.165 14.9614C13.1668 14.92 13.1596 14.848 13.1488 14.7382C13.1218 14.461 13.0714 13.9462 13.1452 13.5448C13.2406 13.066 13.4368 12.6646 13.6834 12.1894L13.6852 12.1876C13.9498 11.6422 14.1082 11.2894 14.0686 10.9132C14.0326 10.573 13.8418 10.222 13.4296 9.5812L13.75 9.322C14.632 10.303 15.2062 11.1976 15.5068 12.0544C15.7516 12.7474 15.7138 13.3018 15.6472 13.7518C15.622 13.9084 15.5752 14.1118 15.532 14.308C15.4636 14.6158 15.3988 14.9074 15.3934 15.0622C15.3898 15.118 15.3988 15.1972 15.4096 15.3052C15.4456 15.667 15.5104 16.3384 15.2278 16.9864C14.9812 17.5426 14.5294 18.0448 14.2594 18.3454C14.155 18.4624 14.0794 18.5452 14.0398 18.6028C13.9876 18.6802 13.966 18.817 13.9354 19.0258C13.8886 19.3426 13.8238 19.7764 13.6042 20.1562C13.1488 20.959 12.2038 21.4306 10.7151 21.5998Z",
      fill: "#217C74"
    }
  ));
}, Lo = m.div`
  border: 1px solid #dfe2e7;
  border-radius: 8px;
  overflow: auto;

  margin-top: 12px;
`, Mo = { ContainerTable: Lo }, vo = (n) => {
  var e = X(n, []);
  return /* @__PURE__ */ r.createElement(de.SVG, N({ width: "14", height: "14", viewBox: "0 0 14 14", fill: "none" }, e), /* @__PURE__ */ r.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.22366 8.69043H9.81616L13.5587 12.4404L12.4412 13.5579L8.69116 9.81543V9.22293L8.48866 9.01293C7.63366 9.74793 6.52366 10.1904 5.31616 10.1904C2.62366 10.1904 0.441162 8.00793 0.441162 5.31543C0.441162 2.62293 2.62366 0.44043 5.31616 0.44043C8.00866 0.44043 10.1912 2.62293 10.1912 5.31543C10.1912 6.52293 9.74866 7.63293 9.01366 8.48793L9.22366 8.69043ZM1.94116 5.31543C1.94116 7.18293 3.44866 8.69043 5.31616 8.69043C7.18366 8.69043 8.69116 7.18293 8.69116 5.31543C8.69116 3.44793 7.18366 1.94043 5.31616 1.94043C3.44866 1.94043 1.94116 3.44793 1.94116 5.31543Z",
      fill: "#696F88"
    }
  ));
}, Fo = (e) => /* @__PURE__ */ r.createElement(hn, N({}, e)), wo = ({
  fields: e,
  findFieldText: n,
  setDisabledNext: t,
  minSizeField: a,
  textTooltipWarning: i
}) => {
  const o = ne(() => e.map((C) => Y(N({}, C), { key: C.id })), [e]), [l, c] = J(o), [s, d] = J([]);
  re(() => {
    t(s.length === 0);
  }, [s]);
  const E = Lt(
    (C, x) => x.size >= a ? x.name : /* @__PURE__ */ r.createElement(r.Fragment, null, x.name, /* @__PURE__ */ r.createElement(Mt, { title: i }, /* @__PURE__ */ r.createElement("span", null, /* @__PURE__ */ r.createElement(Vn, { $marginLeft: "8px", $marginBottom: "-2px" })))),
    [a, i]
  ), f = ne(
    () => [
      {
        title: "Name",
        dataIndex: "name",
        render: E
      },
      {
        title: "Hectares",
        dataIndex: "size",
        width: "120px",
        render: (C, x) => `${x.size.toFixed(2)} ha`
      }
    ],
    [E]
  ), T = (C) => {
    const x = C.target.value;
    c(x ? [
      ...o.filter((S) => S.name.toUpperCase().includes(x.toUpperCase()))
    ] : [...o]);
  }, g = {
    selectedRowKeys: s,
    getCheckboxProps: (C) => ({ disabled: C.size < a }),
    onChange: (C) => {
      d(C);
    }
  };
  return /* @__PURE__ */ r.createElement("div", { "data-testid": Cn.FIELD_STEP_CONTAINER }, /* @__PURE__ */ r.createElement(v.LimitedContainer, { width: "224px" }, /* @__PURE__ */ r.createElement(
    Fo,
    {
      prefix: /* @__PURE__ */ r.createElement(vo, { $margin: "4px" }),
      onChange: T,
      size: "large",
      placeholder: n
    }
  )), /* @__PURE__ */ r.createElement(Mo.ContainerTable, null, /* @__PURE__ */ r.createElement(mn, { pagination: !1, rowSelection: g, columns: f, dataSource: l })));
}, Io = m.div`
  display: flex;
  height: 40px;

  align-items: center;
`, Uo = m(ir)`
  width: 146px;
`, nn = { LineDate: Io, CheckboxSeasonStep: Uo }, rn = ({
  setDisabledNext: e,
  minSizeSeason: n,
  translationOr: t,
  defaultMonthStart: a,
  defaultMonthEnd: i,
  listYearWithRange: o,
  setListYearWithRange: l,
  newRequestCreateJob: c,
  isOffSeason: s,
  maxSizeRangeDate: d
}) => {
  var T;
  re(() => {
    o && c && e(
      To(o, n, d) || !!s && No(c)
    );
  }, [o, c]);
  const E = (h, g) => {
    l(Y(N({}, o), {
      [g]: h.target.checked ? {
        startDate: yo(s ? Number(g) : Number(g) - 1, a),
        endDate: Jn(g, i)
      } : void 0
    }));
  }, f = (h, g, C) => {
    l(Y(N({}, o), {
      [g]: Y(N({}, o[g]), {
        [C]: Dt(h, C)
      })
    }));
  };
  return o ? /* @__PURE__ */ r.createElement(r.Fragment, null, (T = Object.keys(o)) == null ? void 0 : T.reverse().map((h) => /* @__PURE__ */ r.createElement(nn.LineDate, { "data-testid": Fe.SEASON_STEP_CONTAINER, key: h }, /* @__PURE__ */ r.createElement(
    nn.CheckboxSeasonStep,
    {
      "data-testid": Fe.SEASON_STEP_CHECKBOX,
      onChange: (g) => E(g, h),
      checked: !!o[h]
    },
    co(h, t)
  ), o[h] && /* @__PURE__ */ r.createElement(r.Fragment, null, /* @__PURE__ */ r.createElement(ht, { $margin: "0px 12px" }, "de"), /* @__PURE__ */ r.createElement(
    Ht,
    {
      value: o[h].startDate,
      picker: "month",
      onChange: (g) => f(g, h, "startDate"),
      format: "MMM YYYY",
      "data-testid": Fe.SEASON_STEP_START_DATE,
      allowClear: !1
    }
  ), /* @__PURE__ */ r.createElement(ht, { $margin: "0px 12px" }, "a"), /* @__PURE__ */ r.createElement(
    Ht,
    {
      value: o[h].endDate,
      picker: "month",
      onChange: (g) => f(g, h, "endDate"),
      format: "MMM YYYY",
      "data-testid": Fe.SEASON_STEP_END_DATE,
      allowClear: !1
    }
  ))))) : null;
}, bo = m(v.FlexCenter)`
  border-radius: 4px;
  height: 32px;
  width: 98px;

  background-color: #eaf6ff;
  border: 1px solid #eaf6ff;
  margin-bottom: 12px;
`, Ro = m(v.FlexCenter)`
  border-radius: 4px;
  height: 24px;
  width: 98px;

  background-color: #e0f9f7;
  border: 1px solid #e0f9f7;
  margin-bottom: 8px;
`, ko = m(v.FlexCenter)`
  border-radius: 4px;
  height: 24px;
  width: 98px;

  background-color: #fff3dd;
  border: 1px solid #fff3dd;
  margin-bottom: 8px;
`, Ko = m(v.FlexCenter)`
  border-radius: 4px;
  height: 24px;
  width: 98px;

  background-color: transparent;
  margin-bottom: 8px;
  border: 1px dashed #dfe2e7;
  cursor: pointer;
`, Le = { BoxYear: bo, BoxSoy: Ro, BoxOthers: ko, BoxEmpty: Ko }, Oo = ({ year: e, hasSoy: n, hasOthers: t, setCurrentPage: a, currentPage: i }) => /* @__PURE__ */ r.createElement("div", null, /* @__PURE__ */ r.createElement(Le.BoxYear, null, /* @__PURE__ */ r.createElement(R.SmallBold, null, e)), n ? /* @__PURE__ */ r.createElement(Le.BoxSoy, null, /* @__PURE__ */ r.createElement(bt, { $size: "24" }), /* @__PURE__ */ r.createElement(R.Small, null, "Soy")) : /* @__PURE__ */ r.createElement(Le.BoxEmpty, { onClick: () => a(i - 2) }, /* @__PURE__ */ r.createElement(Je, { style: { color: "#A3A9B9" } })), t ? /* @__PURE__ */ r.createElement(Le.BoxOthers, null, /* @__PURE__ */ r.createElement(Ut, { $size: "24" }), " ", /* @__PURE__ */ r.createElement(R.Small, null, "Others")) : /* @__PURE__ */ r.createElement(Le.BoxEmpty, { onClick: () => a(i - 1) }, /* @__PURE__ */ r.createElement(Je, { style: { color: "#A3A9B9" } }))), Po = m.div`
  padding: 24px;
  border: 1px solid #dfe2e7;
  border-radius: 8px;
`, Ho = m.div`
  display: flex;
  justify-content: right;
  border-bottom: 1px solid #dfe2e7;

  padding-bottom: 16px;
  margin-bottom: 16px;
`, an = { Box: Po, ContainerButton: Ho }, Yo = 0, Go = ({
  nemaConfigData: e,
  translations: n,
  setCurrentPage: t,
  currentPage: a,
  setEditFieldCrop: i,
  featuresFlags: o
}) => {
  const l = () => {
    o.editFieldCrop ? i(!0) : t(Yo);
  };
  return /* @__PURE__ */ r.createElement(an.Box, null, /* @__PURE__ */ r.createElement(an.ContainerButton, null, /* @__PURE__ */ r.createElement(le, { onClick: l, $width: "auto" }, n.buttonGoToEditSeason)), /* @__PURE__ */ r.createElement(v.FlexJustifyBetween, null, Object.keys(e.soyYearsWithRange).reverse().map((c) => {
    var s, d;
    return /* @__PURE__ */ r.createElement(
      Oo,
      {
        key: c,
        year: c,
        hasSoy: !!((s = e.soyYearsWithRange[c]) != null && s.startDate),
        hasOthers: !!((d = e.othersYearsWithRange[c]) != null && d.startDate),
        setCurrentPage: t,
        currentPage: a
      }
    );
  })));
}, Vo = (e, n, t, a, i, o, l, c, s, d, E, f, T, h, g, C, x, S, k) => [
  {
    id: "field",
    nameStep: e.nameFieldStep,
    title: e.titleFieldStep,
    subTitle: e.descriptionTitleFieldStep,
    enabled: n.selectFieldNemadigital,
    icon: /* @__PURE__ */ r.createElement(xo, { $marginRight: "8px" }),
    reactNode: /* @__PURE__ */ r.createElement(
      wo,
      {
        textTooltipWarning: e.textTooltipWarning,
        setDisabledNext: t,
        findFieldText: e.findField,
        fields: a,
        minSizeField: i
      }
    )
  },
  {
    id: "soy",
    nameStep: e.nameSoyStep,
    title: e.titleSoyStep,
    subTitle: e.descriptionTitleSoyStep,
    enabled: !0,
    icon: /* @__PURE__ */ r.createElement(bt, { $marginRight: "8px" }),
    reactNode: /* @__PURE__ */ r.createElement(
      rn,
      {
        translationOr: e.translationOr,
        minSizeSeason: o,
        setDisabledNext: t,
        defaultMonthStart: c,
        defaultMonthEnd: s,
        listYearWithRange: f.soyYearsWithRange,
        setListYearWithRange: T,
        newRequestCreateJob: S,
        maxSizeRangeDate: k
      }
    )
  },
  {
    id: "others",
    nameStep: e.nameOthersStep,
    title: e.titleOthersStep,
    subTitle: e.descriptionTitleOthersStep,
    enabled: !0,
    icon: /* @__PURE__ */ r.createElement(Ut, { $marginRight: "8px" }),
    reactNode: /* @__PURE__ */ r.createElement(
      rn,
      {
        translationOr: e.translationOr,
        minSizeSeason: l,
        setDisabledNext: t,
        defaultMonthStart: d,
        defaultMonthEnd: E,
        listYearWithRange: f.othersYearsWithRange,
        setListYearWithRange: h,
        newRequestCreateJob: S,
        maxSizeRangeDate: k,
        isOffSeason: !0
      }
    )
  },
  {
    id: "summary",
    nameStep: e.nameSummaryScreen,
    enabled: n.summaryNemadigital,
    reactNode: /* @__PURE__ */ r.createElement(
      Go,
      {
        currentPage: C,
        translations: e,
        nemaConfigData: f,
        setCurrentPage: g,
        setEditFieldCrop: x,
        featuresFlags: n
      }
    )
  }
].filter((F) => !!F.enabled), Qo = ({
  translations: e,
  goBack: n,
  onSave: t,
  onEndSeasonConfirm: a,
  showEndSeasonButton: i
}) => {
  var l, c;
  const o = [
    {
      key: "1",
      label: /* @__PURE__ */ r.createElement(
        Ft,
        {
          onBackConfirm: n,
          translation: e.backPopConfirm,
          "data-testid": ut.HEADER_EDIT_FIELD_CROP_CANCEL
        },
        (l = e.editFieldCrop) == null ? void 0 : l.cancelAndBack
      )
    },
    {
      key: "2",
      label: e.endSeasonButton.endSeasonButton,
      disabled: !i,
      onClick: () => {
        a();
      }
    }
  ];
  return /* @__PURE__ */ r.createElement(v.Flex, null, /* @__PURE__ */ r.createElement(
    lr.Button,
    {
      "data-testid": ut.HEADER_EDIT_FIELD_CROP_SAVE,
      size: "large",
      onClick: t,
      menu: { items: o },
      type: "primary"
    },
    (c = e.editFieldCrop) == null ? void 0 : c.saveConfiguration
  ));
}, Jo = (e) => {
  const n = /* @__PURE__ */ new Map();
  return e == null || e.forEach((t) => {
    const a = `${t.crop_type}-${t.end_year}`;
    !n.has(a) && t.crop_type && t.end_year && n.set(a, t);
  }), Array.from(n.values());
}, Nt = (e) => (e.sort((n, t) => Number(t.end_year) > Number(n.end_year) ? 1 : Number(t.end_year) < Number(n.end_year) || n.crop_type === "SOYBEAN" && t.crop_type !== "SOYBEAN" ? -1 : 0), e), _o = (e) => {
  var a;
  const n = (a = e == null ? void 0 : e.aois) == null ? void 0 : a.flatMap(
    (i) => Nt(i.crops).map((o) => {
      var l;
      return {
        crop_type: o == null ? void 0 : o.crop_type,
        end_year: (l = o == null ? void 0 : o.year) != null ? l : U(o == null ? void 0 : o.end_date).format("YYYY"),
        end_date: o == null ? void 0 : o.end_date,
        start_date: o == null ? void 0 : o.start_date
      };
    })
  ), t = Jo(n);
  return Nt(t);
}, _n = (e, n) => {
  const t = Nt(n);
  return e.map((a) => {
    const i = t.find((o) => (o == null ? void 0 : o.crop_type) === a.crop_type && (o == null ? void 0 : o.year) === a.end_year);
    return i != null ? i : { crop_type: a.crop_type, end_date: void 0, start_date: void 0, year: a.end_year };
  });
}, zo = (e, n, t) => {
  var i;
  if (!t)
    return [];
  const a = (i = e == null ? void 0 : e.aois) == null ? void 0 : i.find((o) => o.aoi_id === t.id);
  return a ? _n(n, a.crops) : [];
}, jo = {
  [G.SOYBEAN]: "soybeans",
  [G.CORN]: "corn",
  [G.SORGHUM]: "sorghum",
  [G.COTTON]: "cotton",
  [G.WHEAT]: "wheat",
  [G.OTHER]: "others",
  [G.WINTER_WHEAT]: "winterWheat"
}, Zo = (e, n) => {
  var i, o;
  const t = jo[e == null ? void 0 : e.crop_type];
  return `${((i = n.editFieldCrop) == null ? void 0 : i[t]) || ((o = n.editFieldCrop) == null ? void 0 : o.others)} ${e != null && e.start_date && U(e.end_year).format("YYYY") !== U(e.start_date).format("YYYY") ? `${U(e.start_date).format("YYYY")}/` : ""}${e.end_year}`;
}, qo = (e) => {
  const n = U(e.start_date), t = U(e.end_date);
  return `${n.format("MMM/YYYY")} - ${t.format("MMM/YYYY")}`;
}, zn = (e) => Y(N({}, e), {
  aois: e == null ? void 0 : e.aois.map((n) => Y(N({}, n), {
    crops: n == null ? void 0 : n.crops.filter((t) => !!t)
  }))
}), Wo = (e, n, t, a) => (e == null ? void 0 : e.crop_type) === G.SOYBEAN ? n.filter((l) => (l == null ? void 0 : l.crop_type) === G.SOYBEAN).length > t : n.filter((o) => (o == null ? void 0 : o.crop_type) !== G.SOYBEAN).length > a, Xo = (e, n) => {
  const [t, a] = J(e), [i, o] = J(), [l, c] = J();
  return re(() => {
    e && (n != null && n.length) && a(e);
  }, [n == null ? void 0 : n.length, e]), {
    newRequestCreateJob: t,
    editDate: i,
    editAllFields: (h) => {
      if (U(h.start_date).isAfter(U(h.end_date)))
        throw new Error();
      const g = t.aois.map((C) => {
        let x = !1;
        const S = C.crops.map((k) => !k || k.year !== h.year ? k : k.crop_type === h.crop_type ? (x = !0, Y(N({}, k), { start_date: h.start_date, end_date: h.end_date })) : Y(N({}, k), { start_date: void 0, end_date: void 0 }));
        return x || S.push({
          crop_type: h.crop_type,
          start_date: h.start_date,
          end_date: h.end_date,
          year: U(h.end_date).format("YYYY")
        }), Y(N({}, C), { crops: S.sort((k, F) => U(k.end_date).diff(U(F.end_date))) });
      });
      a(Y(N({}, t), { aois: g }));
    },
    deleteFieldCrop: (h, g) => {
      const C = t.aois.map((x) => {
        if (x.aoi_id === g.id) {
          const k = x.crops.map((F) => {
            if (!(!F || F.crop_type === h.crop_type && U(F == null ? void 0 : F.end_date).format("YYYY") === U(h.end_date).format("YYYY")))
              return N({}, F);
          });
          return Y(N({}, x), { crops: k });
        }
        return N({}, x);
      });
      a(Y(N({}, t), {
        aois: C
      }));
    },
    insertFieldCrop: (h, g, C) => {
      const x = t.aois.map((S) => {
        var F, I, P, K;
        if (S.aoi_id === h.id) {
          const V = _n(g, S.crops);
          return V[C] = {
            crop_type: (F = g[C]) == null ? void 0 : F.crop_type,
            end_date: (I = g[C]) == null ? void 0 : I.end_date,
            start_date: (P = g[C]) == null ? void 0 : P.start_date,
            year: U((K = g[C]) == null ? void 0 : K.end_date).format("YYYY")
          }, Y(N({}, S), { crops: V });
        }
        return N({}, S);
      });
      a(Y(N({}, t), {
        aois: x
      }));
    },
    onSaveEditFieldCrop: (h, g) => {
      if (U(h).isAfter(U(g)))
        throw new Error();
      if (!l || !i)
        return;
      const C = U(g).format("YYYY"), x = t.aois.map((S) => {
        if (S.aoi_id !== l.id)
          return N({}, S);
        let k = !1;
        const F = S.crops.map((I) => {
          var K, V;
          return !I || I.year !== i.year ? N({}, I) : fo(I, i) ? (k = !0, Y(N({}, I), {
            start_date: h,
            end_date: g,
            year: C
          })) : uo(
            (K = I == null ? void 0 : I.start_date) != null ? K : "",
            (V = I == null ? void 0 : I.end_date) != null ? V : "",
            h,
            g
          ) ? Y(N({}, I), {
            start_date: void 0,
            end_date: void 0
          }) : N({}, I);
        });
        return k || F.push({
          crop_type: i.crop_type,
          start_date: h,
          end_date: g,
          year: C
        }), Y(N({}, S), { crops: F.sort((I, P) => U(I.end_date).diff(U(P.end_date))) });
      });
      a(Y(N({}, t), { aois: x })), o(void 0), c(void 0);
    },
    openModalEditDate: (h, g) => {
      c(h), o(g);
    }
  };
}, $o = (e) => ne(() => {
  var n, t;
  return new Map(
    (t = (n = e == null ? void 0 : e.aois) == null ? void 0 : n.map(({ aoi_id: a, isLoading: i, hasError: o, crops: l }) => {
      const c = l.some(
        (s) => !(s != null && s.start_date) || !(s != null && s.end_date)
      );
      return [
        a,
        {
          isLoading: i,
          hasError: o || c
        }
      ];
    })) != null ? t : []
  );
}, [e]), ei = m(v.FlexJustifyBetween)`
  padding: 0 8px 0 0;
  align-items: center;
  gap: 8px;

  svg  {
    height: 18px;
    width: 18px;
    color: ${j.RED_60};
  }
`, ti = m(v.FlexColumn)`
`, ni = m(v.FlexJustifyBetween)`
  gap: 8px;
  margin-top: 12px;
`, Bt = { Container: ei, ContentFieldName: ti, ColumnTitleContent: ni }, ri = ({ field: e, hasError: n, tooltipTranslation: t }) => /* @__PURE__ */ r.createElement(Bt.Container, null, /* @__PURE__ */ r.createElement(Bt.ContentFieldName, null, /* @__PURE__ */ r.createElement(Sn, { maxLength: 40 }, e.name), /* @__PURE__ */ r.createElement(R.Description, { $marginTop: "8px", $color: "#696F88" }, `${e.size.toFixed(2)} ha`)), n && /* @__PURE__ */ r.createElement(Mt, { title: t }, /* @__PURE__ */ r.createElement(La, null))), ai = (n) => {
  var e = X(n, []);
  return /* @__PURE__ */ r.createElement("svg", N({ width: "18", height: "18", viewBox: "0 0 18 18", fill: "none" }, e), /* @__PURE__ */ r.createElement(
    "path",
    {
      d: "M14.25 4.8075L13.1925 3.75L9 7.9425L4.8075 3.75L3.75 4.8075L7.9425 9L3.75 13.1925L4.8075 14.25L9 10.0575L13.1925 14.25L14.25 13.1925L10.0575 9L14.25 4.8075Z",
      fill: "#C2C7D0"
    }
  ));
}, oi = m(v.FlexJustifyBetween)`
  width: 100%;
  align-items: center;
  height: 24px;
  margin: 12px 0px;
`, ii = m(ai)`
  cursor: pointer;
`, on = { Container: oi, IconClose: ii }, li = ({ title: e, onClose: n }) => /* @__PURE__ */ r.createElement(on.Container, { "data-testid": Ve.DATE_EDIT_TITLE_CONTAINER }, /* @__PURE__ */ r.createElement(R.SubTitle, { "data-testid": Ve.DATE_EDIT_TITLE_TEXT }, e), /* @__PURE__ */ r.createElement(on.IconClose, { onClick: n, "data-testid": Ve.DATE_EDIT_TITLE_ICON })), ci = m.div`
  margin-top: 36px;
`, si = m(v.FlexJustifyBetween)`
  margin-top: 16px;
  flex-wrap: wrap;
`, di = m(v.FlexCenter)`
  height: 32px;
  width: 22%;
  background-color: ${(e) => e.isSelected ? "#0071CD" : "#f3f4f6"};
  color: ${(e) => e.isSelected ? "white" : "#14151C"};
  margin-bottom: 12px;
  border-radius: 4px;
  cursor: pointer;
`, Ei = m(v.FlexCenter)`
  width: 24px;
  height: 24px;
  border-radius: 12px;
  background-color: #f3f4f6;
  cursor: pointer;
  margin-right: ${(e) => e.isRight ? "0px" : "8px"};
  margin-left: ${(e) => e.isRight ? "8px" : "0px"};

  svg {
    transform: ${(e) => e.isRight ? "rotate(180deg)" : "rotate(0deg)"};
  }
`, Me = { Container: ci, ContainerMonths: si, BoxMonth: di, BoxArrow: Ei }, ln = ({ title: e, date: n, onChangeDate: t, isStart: a = !0, minYear: i, maxYear: o }) => {
  const l = ne(() => Array.from(Array(12).keys()), []), c = (d) => {
    const E = Dt(U(n), a ? "startDate" : "endDate");
    d > 0 && E.add(d, "year").year() > o || d < 0 && E.add(d, "year").year() < i || t(E.add(d, "year").format("YYYY-MM-DD"));
  }, s = (d) => {
    const E = Dt(U(n), a ? "startDate" : "endDate");
    t(E.month(d).format("YYYY-MM-DD"));
  };
  return /* @__PURE__ */ r.createElement(Me.Container, { "data-testid": Ce.MONTH_CALENDAR_CONTAINER }, /* @__PURE__ */ r.createElement(v.FlexJustifyBetween, null, /* @__PURE__ */ r.createElement(R.SubTitle, { "data-testid": Ce.MONTH_CALENDAR_TITLE }, e), /* @__PURE__ */ r.createElement(v.FlexCenter, null, /* @__PURE__ */ r.createElement(
    Me.BoxArrow,
    {
      onClick: () => c(-1),
      "data-testid": Ce.MONTH_CALENDAR_LEFT_ARROW
    },
    /* @__PURE__ */ r.createElement(mt, null)
  ), /* @__PURE__ */ r.createElement(R.SubTitle, { "data-testid": Ce.MONTH_CALENDAR_DATE }, U(n).format("YYYY")), /* @__PURE__ */ r.createElement(
    Me.BoxArrow,
    {
      isRight: !0,
      onClick: () => c(1),
      "data-testid": Ce.MONTH_CALENDAR_RIGHT_ARROW
    },
    /* @__PURE__ */ r.createElement(mt, null)
  ))), /* @__PURE__ */ r.createElement(Me.ContainerMonths, null, l.map((d) => /* @__PURE__ */ r.createElement(
    Me.BoxMonth,
    {
      key: `month_${d}`,
      isSelected: Number(U(n).format("MM")) === d + 1,
      onClick: () => s(d),
      "data-testid": Ce.MONTH_CALENDAR_BOX_MONTH
    },
    /* @__PURE__ */ r.createElement(R.Small, null, Jn(U(n).format("YYYY"), d + 1).format("MMM").toUpperCase())
  ))));
}, fi = m.div`
  z-index: 3;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
`, ui = m(v.FlexColumn)`
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 3;
  position: fixed;
  width: 290px;
  background-color: white;
  padding: 16px;
  justify-content: space-between;
`, cn = { Shadow: fi, Body: ui }, jn = ({
  open: e,
  onSave: n,
  onClose: t,
  startDate: a,
  endDate: i,
  canEditEndYear: o,
  translation: l,
  errorMessage: c,
  callbackOnChange: s,
  maxSizeRangeDate: d,
  currentYear: E
}) => {
  const [f, T] = J(""), [h, g] = J(a), [C, x] = J(i);
  re(() => {
    a && i ? (g(a), x(i)) : E && (g(`${E}-04-01`), x(`${E}-11-30`));
  }, [a, i, E]), re(() => {
    T(c);
  }, [c]), re(() => {
    s && s();
  }, [h, C]);
  const S = (K) => {
    g(K);
  }, k = (K) => {
    x(K);
  }, F = () => {
    t();
  }, I = () => {
    n(h, C);
  }, P = () => {
    const K = U(h), V = U(C);
    return d && V.diff(K, "months") > d ? !0 : K.toDate().getTime() > V.toDate().getTime();
  };
  return e ? /* @__PURE__ */ r.createElement(r.Fragment, null, /* @__PURE__ */ r.createElement(cn.Shadow, { "data-testid": we.DATE_EDIT_MODAL_SHADOW }), /* @__PURE__ */ r.createElement(cn.Body, { "data-testid": we.DATE_EDIT_MODAL_BODY }, /* @__PURE__ */ r.createElement("div", null, /* @__PURE__ */ r.createElement(li, { title: l == null ? void 0 : l.title, onClose: F }), /* @__PURE__ */ r.createElement(
    ln,
    {
      title: l == null ? void 0 : l.startCalendarTitle,
      date: h,
      onChangeDate: S,
      maxYear: Number(U(C).format("YYYY"))
    }
  ), /* @__PURE__ */ r.createElement(
    ln,
    {
      title: l == null ? void 0 : l.endCalendarTitle,
      date: C,
      onChangeDate: k,
      isStart: !1,
      maxYear: o ? void 0 : Number(U(C).format("YYYY")),
      minYear: o ? void 0 : Number(U(C).format("YYYY"))
    }
  )), /* @__PURE__ */ r.createElement(v.FlexColumn, null, /* @__PURE__ */ r.createElement(R.Bold, { $margin: "0px 0px 16px auto", $color: "#EB4B4B" }, f), /* @__PURE__ */ r.createElement(v.Flex, null, /* @__PURE__ */ r.createElement(le, { "data-testid": we.DATE_EDIT_MODAL_CANCEL, onClick: F }, l == null ? void 0 : l.cancel), /* @__PURE__ */ r.createElement(
    le,
    {
      "data-testid": we.DATE_EDIT_MODAL_SAVE,
      disabled: P(),
      onClick: I,
      type: "primary",
      $marginLeft: "8px"
    },
    l == null ? void 0 : l.save
  ))))) : null;
}, hi = m((e) => /* @__PURE__ */ r.createElement(mn, Y(N({}, e), { pagination: !1 })))`
  .nemaant-table-thead > tr > th {
    background-color: white;
    border: none;
    text-align: start !important;
  }

  .nemaant-table-cell.field-column {
    border-right: 1px solid ${j.NEUTRAL_10} !important;
  }

  .nemaant-table-cell.current-season-column {
    border-right: 1px solid #000 !important;
  }

  .nemaant-table-cell.divider-column {
    background-color: #000 !important;
    width: 1px !important;
    padding: 0 !important;
  }

  .nemaant-table-cell {
    padding: 8px !important;
  }

  .nemaant-table-cell::before {
    content: none !important;
  }

  .nemaant-skeleton-title {
    height: 32px !important;
    margin: 0 !important;
  }
`, mi = { StyledTable: hi }, gi = (n) => {
  var e = X(n, []);
  return /* @__PURE__ */ r.createElement(de.SVG, Y(N({ width: e.width, height: e.height }, e), { xmlns: "http://www.w3.org/2000/svg" }), /* @__PURE__ */ r.createElement(
    "path",
    {
      d: "M5.57422 6.99L9.45392 3L13.3336 6.99H10.4238V14H8.48399V6.99H5.57422ZM16.2437 10.0001V17.0101H19.1534L15.2737 21.0001L11.394 17.0101H14.3038V10.0001H16.2437Z",
      fill: e.fill
    }
  ));
}, Ci = ({
  translations: e,
  sortOrder: n,
  searchField: t,
  setSortOrder: a,
  setSearchField: i
}) => {
  const o = Lt(() => {
    a({
      ascend: "descend",
      descend: "",
      "": "ascend"
    }[n]);
  }, [a, n]);
  return /* @__PURE__ */ r.createElement(r.Fragment, null, /* @__PURE__ */ r.createElement(R.SubTitle, null, e == null ? void 0 : e.selectedFields), /* @__PURE__ */ r.createElement(Bt.ColumnTitleContent, null, /* @__PURE__ */ r.createElement(
    hn,
    {
      prefix: /* @__PURE__ */ r.createElement(Pa, { style: { color: j.NEUTRAL_60 } }),
      placeholder: e == null ? void 0 : e.searchFieldPlaceholder,
      value: t,
      onChange: (l) => i(l.target.value)
    }
  ), /* @__PURE__ */ r.createElement(un, { type: "ghost", onClick: o, icon: /* @__PURE__ */ r.createElement(gi, { height: "24", width: "24", fill: j.NEUTRAL_60 }) })));
}, _e = (a) => {
  var i = a, {
    size: e = 18,
    fillPath: n = "white"
  } = i, t = X(i, [
    "size",
    "fillPath"
  ]);
  return /* @__PURE__ */ r.createElement("svg", N({ width: `${e}`, height: `${e}`, viewBox: "0 0 18 18" }, t), /* @__PURE__ */ r.createElement(
    "path",
    {
      d: "M13.2441 2.25C13.0566 2.25 12.8616 2.325 12.7191 2.4675L11.3466 3.84L14.1591 6.6525L15.5316 5.28C15.8241 4.9875 15.8241 4.515 15.5316 4.2225L13.7766 2.4675C13.6266 2.3175 13.4391 2.25 13.2441 2.25ZM10.5441 6.765L11.2341 7.455L4.43905 14.25H3.74905V13.56L10.5441 6.765ZM2.24905 12.9386L10.5441 4.64355L13.3566 7.45605L5.06155 15.7511H2.24905V12.9386Z",
      fill: n
    }
  ));
}, Ai = m.th`
  width: 100%;
  margin: 10px 8px;
`, pi = m(v.FlexAlignCenter)`
  background-color: ${(e) => e.isSoybean ? "#e0f9f7" : "#FFF3DD"};
  height: 32px;
  width: 264px;
  border-radius: 4px;
  padding: 0px 8px;
  justify-content: space-between;
`, sn = {
  BoxHeader: pi,
  ColumnHeader: Ai
}, Si = ({ dateCrop: e, setDateCropEdit: n, translations: t }) => /* @__PURE__ */ r.createElement(
  sn.ColumnHeader,
  {
    key: `field_crop_header_${e.crop_type}_${e.end_year}`,
    "data-testid": Ue.SEASON_COLUMN_CARD_CONTAINER
  },
  /* @__PURE__ */ r.createElement(sn.BoxHeader, { isSoybean: e.crop_type === G.SOYBEAN }, /* @__PURE__ */ r.createElement(v.FlexCenter, null, e.crop_type === G.SOYBEAN ? /* @__PURE__ */ r.createElement(bt, { $size: "24" }) : /* @__PURE__ */ r.createElement(Ut, { $size: "24" }), /* @__PURE__ */ r.createElement(R.Bold, null, Zo(e, t))), /* @__PURE__ */ r.createElement(_e, { style: { cursor: "pointer" }, fillPath: "#696F88", onClick: () => n(e) }))
), Ti = (n) => {
  var e = X(n, []);
  return /* @__PURE__ */ r.createElement(
    "svg",
    N({
      fill: "#696F88",
      version: "1.1",
      width: "12px",
      height: "12px",
      viewBox: "0 0 482.428 482.429",
      xmlSpace: "preserve"
    }, e),
    /* @__PURE__ */ r.createElement("g", null, /* @__PURE__ */ r.createElement("g", null, /* @__PURE__ */ r.createElement("path", { d: "M381.163,57.799h-75.094C302.323,25.316,274.686,0,241.214,0c-33.471,0-61.104,25.315-64.85,57.799h-75.098    c-30.39,0-55.111,24.728-55.111,55.117v2.828c0,23.223,14.46,43.1,34.83,51.199v260.369c0,30.39,24.724,55.117,55.112,55.117    h210.236c30.389,0,55.111-24.729,55.111-55.117V166.944c20.369-8.1,34.83-27.977,34.83-51.199v-2.828    C436.274,82.527,411.551,57.799,381.163,57.799z M241.214,26.139c19.037,0,34.927,13.645,38.443,31.66h-76.879    C206.293,39.783,222.184,26.139,241.214,26.139z M375.305,427.312c0,15.978-13,28.979-28.973,28.979H136.096    c-15.973,0-28.973-13.002-28.973-28.979V170.861h268.182V427.312z M410.135,115.744c0,15.978-13,28.979-28.973,28.979H101.266    c-15.973,0-28.973-13.001-28.973-28.979v-2.828c0-15.978,13-28.979,28.973-28.979h279.897c15.973,0,28.973,13.001,28.973,28.979    V115.744z" }), /* @__PURE__ */ r.createElement("path", { d: "M171.144,422.863c7.218,0,13.069-5.853,13.069-13.068V262.641c0-7.216-5.852-13.07-13.069-13.07    c-7.217,0-13.069,5.854-13.069,13.07v147.154C158.074,417.012,163.926,422.863,171.144,422.863z" }), /* @__PURE__ */ r.createElement("path", { d: "M241.214,422.863c7.218,0,13.07-5.853,13.07-13.068V262.641c0-7.216-5.854-13.07-13.07-13.07    c-7.217,0-13.069,5.854-13.069,13.07v147.154C228.145,417.012,233.996,422.863,241.214,422.863z" }), /* @__PURE__ */ r.createElement("path", { d: "M311.284,422.863c7.217,0,13.068-5.853,13.068-13.068V262.641c0-7.216-5.852-13.07-13.068-13.07    c-7.219,0-13.07,5.854-13.07,13.07v147.154C298.213,417.012,304.067,422.863,311.284,422.863z" })))
  );
}, yi = m(v.FlexJustifyBetween)`
  border-radius: 4px;
  border: 1px solid #dfe2e7;
  padding: 16px;
  align-items: center;
`, Di = m(v.FlexCenter)`
  border-radius: 4px;
  border: 1px dashed #dfe2e7;
  padding: 16px;
  align-items: center;
  cursor: pointer;
`, Ni = m(Ti)`
  margin-left: 6px;
  cursor: ${(e) => e.disabled ? "default" : "pointer"};

  fill: ${(e) => e.disabled ? "#e4e7f0" : "#696F88"};
`, ct = { BoxColumn: yi, BoxColumnInsert: Di, DeleteIcon: Ni }, Bi = (t) => {
  var a = t, { fillPath: e = "white" } = a, n = X(a, ["fillPath"]);
  return /* @__PURE__ */ r.createElement(de.SVG, N({ width: "12", height: "12", viewBox: "0 0 12 12", fill: "none" }, n), /* @__PURE__ */ r.createElement("path", { d: "M11.25 6.75H6.75V11.25H5.25V6.75H0.75V5.25H5.25V0.75H6.75V5.25H11.25V6.75Z", fill: e }));
}, xi = ({
  deleteFieldCrop: e,
  insertFieldCrop: n,
  openEditDate: t,
  field: a,
  listHeaderColumns: i,
  requestCrop: o,
  index: l,
  isEnabledDelete: c,
  cropInfoQueries: s
}) => o && o.crop_type && o.end_date && o.start_date ? /* @__PURE__ */ r.createElement(ct.BoxColumn, { "data-testid": Ue.SEASON_COLUMN_CELL_CONTAINER }, /* @__PURE__ */ r.createElement(R.Description, null, qo(o)), /* @__PURE__ */ r.createElement(v.Flex, null, /* @__PURE__ */ r.createElement(_e, { style: { cursor: "pointer" }, size: 14, fillPath: "#696F88", onClick: t }), /* @__PURE__ */ r.createElement(
  ct.DeleteIcon,
  {
    disabled: !c,
    onClick: () => c ? e(o, a) : () => null
  }
))) : /* @__PURE__ */ r.createElement(
  ct.BoxColumnInsert,
  {
    onClick: () => s != null && s.length ? t() : n(a, i, l)
  },
  /* @__PURE__ */ r.createElement(Bi, { fillPath: "#696F88" })
), Li = ({
  deleteFieldCrop: e,
  field: n,
  fieldCropMap: t,
  insertFieldCrop: a,
  listColumns: i,
  minSizeSeasonOthers: o,
  minSizeSeasonSoy: l,
  openModalEditDate: c,
  requestCreateJob: s,
  columnKey: d,
  index: E,
  cropInfoQueries: f
}) => {
  const T = t.get(n.id), h = zo(s, i, n), g = h.find((C) => `${C.crop_type}_${C.year}` === d);
  return /* @__PURE__ */ r.createElement(gn, { loading: T == null ? void 0 : T.isLoading, active: !0, paragraph: !1 }, /* @__PURE__ */ r.createElement(
    xi,
    {
      index: E,
      cropInfoQueries: f,
      field: n,
      requestCrop: g,
      deleteFieldCrop: e,
      insertFieldCrop: a,
      openEditDate: () => c(n, g),
      listHeaderColumns: i,
      isEnabledDelete: Wo(g, h, l, o)
    }
  ));
}, Mi = ({
  requestCreateJob: e,
  fields: n,
  translations: t,
  deleteFieldCrop: a,
  insertFieldCrop: i,
  openModalEditDate: o,
  editAllFields: l,
  minSizeSeasonSoy: c,
  minSizeSeasonOthers: s,
  maxSizeRangeDate: d,
  cropInfoQueries: E
}) => {
  var A, M;
  const [f, T] = J(), [h, g] = J(""), [C, x] = J(""), [S, k] = J(""), F = ne(() => _o(e), [e]), I = $o(e), P = Math.max(...F.map((u) => Number(u.end_year))), K = F.filter((u) => Number(u.end_year) === P), V = F.filter((u) => Number(u.end_year) < P), W = ne(() => n.filter((u) => !C || u.name.toLowerCase().includes(C.toLowerCase())).sort((u, y) => S === "ascend" ? u.name.localeCompare(y.name) : S === "descend" ? y.name.localeCompare(u.name) : 0), [n, C, S]), b = (u, y) => {
    var D;
    if (f) {
      const O = {
        crop_type: f.crop_type,
        start_date: u,
        end_date: y,
        year: f.end_year
      };
      try {
        l(O), T(void 0);
      } catch (Q) {
        g(((D = t.dateEditModal) == null ? void 0 : D.errorMessageDate) || "");
      }
    }
  }, L = () => g(""), te = ne(() => ({
    title: /* @__PURE__ */ r.createElement(
      Ci,
      {
        translations: t.editFieldCrop,
        searchField: C,
        setSearchField: x,
        setSortOrder: k,
        sortOrder: S
      }
    ),
    dataIndex: "fieldName",
    key: "fieldName",
    fixed: "left",
    className: "field-column",
    width: 250,
    render: (u, y) => {
      const D = I.get(y.id);
      return /* @__PURE__ */ r.createElement(gn, { loading: D == null ? void 0 : D.isLoading, active: !0, paragraph: !1 }, /* @__PURE__ */ r.createElement(ri, { field: y, hasError: D == null ? void 0 : D.hasError, tooltipTranslation: t.editFieldCrop.tooltipError }));
    }
  }), [I, C, S, t.editFieldCrop]), ce = Lt(
    (u) => u.map((y, D) => {
      const O = `${y.crop_type}_${y.end_year}`;
      return {
        title: /* @__PURE__ */ r.createElement(Si, { dateCrop: y, translations: t, setDateCropEdit: T }),
        dataIndex: O,
        key: O,
        render: (Q, H) => /* @__PURE__ */ r.createElement(
          Li,
          {
            cropInfoQueries: E,
            index: D,
            field: H,
            dateCrop: y,
            columnKey: O,
            deleteFieldCrop: a,
            fieldCropMap: I,
            insertFieldCrop: i,
            listColumns: F,
            minSizeSeasonOthers: s,
            minSizeSeasonSoy: c,
            openModalEditDate: o,
            requestCreateJob: e
          }
        )
      };
    }),
    [
      t,
      I,
      e,
      F,
      a,
      i,
      c,
      s,
      o
    ]
  ), B = ne(() => {
    var u, y;
    return [
      te,
      {
        title: /* @__PURE__ */ r.createElement(R.Bold, { "data-testid": Ue.CURRENT_SEASON_COLUMN_TITLE_CONTAINER, $fontSize: "16px" }, (u = t.editFieldCrop) == null ? void 0 : u.currentSeason),
        children: ce(K)
      },
      {
        dataIndex: "divider",
        className: "divider-column",
        key: "divider",
        width: 1
      },
      {
        title: /* @__PURE__ */ r.createElement(R.Bold, { "data-testid": Ue.PAST_SEASON_COLUMN_TITLE_CONTAINER, $fontSize: "16px" }, (y = t.editFieldCrop) == null ? void 0 : y.pastSeason),
        children: ce(V)
      }
    ];
  }, [
    te,
    (A = t.editFieldCrop) == null ? void 0 : A.currentSeason,
    (M = t.editFieldCrop) == null ? void 0 : M.pastSeason,
    ce,
    K,
    V
  ]), p = ne(
    () => W.map((u) => Y(N({}, u), {
      key: u.id,
      fieldName: u.name
    })),
    [W]
  );
  return /* @__PURE__ */ r.createElement(r.Fragment, null, /* @__PURE__ */ r.createElement(
    jn,
    {
      startDate: f == null ? void 0 : f.start_date,
      endDate: f == null ? void 0 : f.end_date,
      onClose: () => T(void 0),
      onSave: b,
      open: !!(f != null && f.end_year),
      translation: t.dateEditModal,
      currentYear: f == null ? void 0 : f.end_year,
      canEditEndYear: !1,
      errorMessage: h,
      callbackOnChange: L,
      maxSizeRangeDate: d
    }
  ), /* @__PURE__ */ r.createElement(mi.StyledTable, { dataSource: p, columns: B, scroll: { x: "max-content" } }));
}, vi = m(v.Flex)`
  min-width: 100%;
  background-color: white;
  overflow: auto;
  height: calc(100vh - 120px);
`, Fi = { Container: vi }, wi = ({
  translations: e,
  setEditFieldCrop: n,
  requestCreateJob: t,
  fields: a,
  onSaveNewRequestCreateJob: i,
  minSizeSeasonSoy: o,
  minSizeSeasonOthers: l,
  maxSizeRangeDate: c,
  cropInfoQueries: s,
  createJob: d,
  onBack: E,
  showEndSeasonButton: f,
  onEndSeasonConfirm: T,
  showCropLandDataLayerEdit: h
}) => {
  const [g, C] = J(""), { openModalEditDate: x, editDate: S, deleteFieldCrop: k, insertFieldCrop: F, onSaveEditFieldCrop: I, editAllFields: P, newRequestCreateJob: K } = Xo(t, s), V = () => {
    n(!1), h && E && E();
  }, W = (te, ce) => {
    var B;
    try {
      I(te, ce), x();
    } catch (p) {
      C((B = e.dateEditModal) == null ? void 0 : B.errorMessageDate);
    }
  }, b = () => {
    if (s != null && s.length && h) {
      d(zn(K));
      return;
    }
    i(K), V();
  }, L = () => {
    C("");
  };
  return /* @__PURE__ */ r.createElement(ze, null, /* @__PURE__ */ r.createElement(
    jn,
    {
      startDate: S == null ? void 0 : S.start_date,
      endDate: S == null ? void 0 : S.end_date,
      onClose: x,
      currentYear: S == null ? void 0 : S.year,
      onSave: W,
      open: !!(S != null && S.crop_type) && !!(S != null && S.year),
      translation: e.dateEditModal,
      canEditEndYear: !1,
      errorMessage: g,
      callbackOnChange: L,
      maxSizeRangeDate: c
    }
  ), /* @__PURE__ */ r.createElement(
    Qn,
    {
      translation: e.header,
      translationPopconfirm: e.backPopConfirm,
      onBackConfirm: V,
      customHeader: /* @__PURE__ */ r.createElement(
        Qo,
        {
          onSave: b,
          goBack: V,
          translations: e,
          onEndSeasonConfirm: T,
          showEndSeasonButton: f
        }
      )
    }
  ), /* @__PURE__ */ r.createElement(Fi.Container, { "data-testid": pn.EDIT_FIELD_CROP_BODY }, /* @__PURE__ */ r.createElement(
    Mi,
    {
      cropInfoQueries: s,
      translations: e,
      requestCreateJob: K,
      insertFieldCrop: F,
      deleteFieldCrop: k,
      fields: a,
      openModalEditDate: x,
      editAllFields: P,
      minSizeSeasonOthers: l,
      minSizeSeasonSoy: o,
      maxSizeRangeDate: c
    }
  )));
}, L1 = ({
  fields: e,
  translations: n,
  minSizeField: t,
  minSizeSeasonSoy: a,
  minSizeSeasonOthers: i,
  featuresFlags: o,
  amountYearsSeason: l,
  defaultMonthStartSoy: c,
  defaultMonthEndSoy: s,
  defaultMonthStartOthers: d,
  defaultMonthEndOthers: E,
  cropCycleStart: f,
  cropCycleEnd: T,
  workspaceId: h,
  contractId: g,
  previousRequestCreateJob: C,
  startLoading: x,
  stepLoading: S,
  showHeaderSteps: k,
  maxSizeRangeDate: F,
  onBack: I,
  createJob: P,
  showEndSeasonButton: K,
  onEndSeasonConfirm: V,
  cropInfoQueries: W,
  showCropLandDataLayerEdit: b
}) => {
  const {
    disabledNext: L,
    nemaConfigData: te,
    showEditFieldCrop: ce,
    newRequestCreateJob: B,
    handleOnChangeSoyYears: p,
    handleOnChangeOthersYears: A,
    setDisabledNext: M,
    setEditFieldCrop: u,
    currentPage: y,
    setCurrentPage: D,
    setNewRequestCreateJob: O
  } = Bo(
    l,
    o,
    e,
    C,
    f,
    T,
    h,
    g,
    W,
    b
  );
  re(() => {
    b && u(!0);
  }, [u, b]);
  const Q = (Z) => {
    var oe;
    ((oe = H[H.length - 1]) == null ? void 0 : oe.id) === Z && P(zn(B));
  }, H = ne(
    () => Vo(
      n,
      o,
      M,
      e,
      t,
      a,
      i,
      c,
      s,
      d,
      E,
      te,
      p,
      A,
      D,
      y,
      u,
      B,
      F
    ),
    [n, o, te, B]
  );
  return ce || b ? /* @__PURE__ */ r.createElement(
    wi,
    {
      fields: e,
      requestCreateJob: B,
      translations: n.setupForm,
      setEditFieldCrop: u,
      onSaveNewRequestCreateJob: O,
      minSizeSeasonOthers: i,
      minSizeSeasonSoy: a,
      maxSizeRangeDate: F,
      cropInfoQueries: W,
      createJob: P,
      onBack: I,
      showCropLandDataLayerEdit: b,
      showEndSeasonButton: K,
      onEndSeasonConfirm: V
    }
  ) : /* @__PURE__ */ r.createElement(
    ro,
    {
      onBack: I,
      steps: H,
      disabledNext: L,
      callbackNext: Q,
      translations: n.setupForm,
      currentPageProps: y,
      setCurrentPageProps: D,
      startLoading: x,
      stepLoading: S,
      showHeaderSteps: k,
      showEndSeasonButton: K,
      onEndSeasonConfirm: V
    }
  );
};
var Rt = /* @__PURE__ */ ((e) => (e.CREATED = "CREATED", e.IN_QUEUE = "IN_QUEUE", e.PROCESSING = "PROCESSING", e.FINISHED = "FINISHED", e.EDITED = "EDITED", e.ARCHIVED = "ARCHIVED", e.FAILED = "FAILED", e))(Rt || {}), w = /* @__PURE__ */ ((e) => (e.AREAS_LABEL = "areas-label", e.AREAS_LABEL_SOURCE = "areas-label-source", e.AREAS_SOURCE = "areas-source", e.AREAS_BOUNDARY = "areas-boundary", e.NEMADIGITAL_SOURCE = "nemadigital-source", e.NEMADIGITAL_LAYER = "nemadigital-layer", e.NEMADIGITAL_FILL = "nemadigital-fill", e.NEMADIGITAL_INTENSITY_FILL = "nemadigital-intensity-fill", e.NEMADIGITAL_DAMAGE_LABEL = "nemadigital-damage-label", e))(w || {}), se = /* @__PURE__ */ ((e) => (e.CHOROPLETH_MAP = "damageMap", e.INTENSITY_MAP = "intensityMap", e))(se || {});
const dn = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEkAAAAcCAYAAAAtMJKYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFuSURBVHgB7ZndbYNAEITnXEFKIBXErsChA1xBcAkpIZ0kFZgO4lRgXAGkgtAB2QHOOpDZIMUvmP2k0YEPWWI098OtwwTqun6WJhFtRZHoAfOlEuWisyhzzh3xH8ScVFTU900hSjUf3Ig5kTQH0RrLoRTFkqxy2LEa/iAGvUhzwrIMIpHoJO+fDDt6SeoeOMBIJVEf/uZiUjfEmKA5T8q3gpP7xg+90KQCbeSMllxM2vCimZO62T2CEbL2q16TJEvRKKWk6dHV7UbxE8YYMYdbAkMjoUlPMDS2HG4/sGVfo6JJNQyVFYw/oUkVDI2KJpUwNM406QuGRk6TMhgamX2W6DSfJX51e4NxjcaX8KhkiaeRGk2KeBHuk3aw7YCHPsT+5mJSdwr3CoPsw4JAb8ctHe9YdqL43jSot+JrJSWeMUVYDixY7iaVlAgf7CatPe5/R16iTc/mmkHETfiTsMzN1Y/nT3Mvc3+LjphY5v4FvZ9XuRa09O0AAAAASUVORK5CYII=", kt = [
  {
    value: 1,
    color: "#FFB59D"
  },
  {
    value: 4,
    color: "#FFB59D"
  },
  {
    value: 2,
    color: "#C1462B"
  },
  {
    value: 5,
    color: "#C1462B"
  },
  {
    value: 3,
    color: "#48150A"
  },
  {
    value: 6,
    color: "#48150A"
  }
], Zn = () => {
  const e = ["case"];
  return kt.forEach((n) => {
    const t = ["==", ["get", "value"], n.value];
    e.push(t), e.push(n.color);
  }), e.push("transparent"), e;
}, qn = (e) => {
  const n = `${w.NEMADIGITAL_SOURCE}-${e.properties.id}`, t = `${w.NEMADIGITAL_LAYER}-${e.properties.id}`, a = `${w.NEMADIGITAL_INTENSITY_FILL}-${e.properties.id}`;
  return { sourceId: n, layerId: t, intensityFillLayerId: a };
}, Ii = (e) => {
  e.getLayer(w.NEMADIGITAL_DAMAGE_LABEL) || e.addLayer({
    id: w.NEMADIGITAL_DAMAGE_LABEL,
    type: "symbol",
    source: w.AREAS_LABEL,
    minzoom: 13,
    layout: {
      "text-field": ["format", ["case", ["has", "nematodeDamage"], ["get", "nematodeDamage"], " "]],
      "text-size": 12,
      "text-font": ["Open Sans Bold"],
      "text-variable-anchor": ["top", "bottom", "left", "right"],
      "text-radial-offset": 1,
      "icon-text-fit": "both",
      "icon-text-fit-padding": [2, 5, 2, 5],
      "text-justify": "center",
      "text-anchor": "bottom",
      "icon-anchor": "bottom"
    },
    filter: ["has", "nematodeDamage"],
    paint: {
      "text-color": "gray"
    }
  });
}, Ui = (e) => {
  e.getLayer(w.NEMADIGITAL_FILL) || e.addLayer(
    {
      id: w.NEMADIGITAL_FILL,
      type: "fill",
      source: w.AREAS_SOURCE,
      filter: ["==", "$type", "Polygon"],
      paint: {
        "fill-color": ["get", "nematodeColor"],
        "fill-opacity": ["case", ["has", "nematodeColor"], 1, 0]
      }
    },
    w.AREAS_BOUNDARY
  );
}, bi = (e, n, t, a, i) => {
  i.getSource(n) || i.addSource(n, {
    type: "geojson",
    data: e
  }), !i.getLayer(t) && (i.addLayer(
    {
      id: t,
      type: "line",
      source: n,
      paint: {
        "line-color": "#fff",
        "line-width": 0
      },
      filter: ["match", ["geometry-type"], ["Polygon", "MultiPolygon"], !0, !1]
    },
    w.AREAS_BOUNDARY
  ), i.addLayer(
    {
      id: a,
      type: "fill",
      source: n,
      filter: ["match", ["geometry-type"], ["Polygon", "MultiPolygon"], !0, !1],
      paint: {
        "fill-color": "transparent"
      }
    },
    w.AREAS_BOUNDARY
  ));
}, Ri = (e) => {
  e.getSource(w.NEMADIGITAL_SOURCE) || e.addSource(w.NEMADIGITAL_SOURCE, {
    type: "geojson",
    data: {
      type: "FeatureCollection",
      features: []
    }
  }), !e.getLayer(w.NEMADIGITAL_LAYER) && (e.addLayer(
    {
      id: w.NEMADIGITAL_LAYER,
      type: "line",
      source: w.NEMADIGITAL_SOURCE,
      paint: {
        "line-color": "#fff",
        "line-width": 0
      },
      filter: ["match", ["geometry-type"], ["Polygon", "MultiPolygon"], !0, !1]
    },
    w.AREAS_BOUNDARY
  ), e.addLayer(
    {
      id: w.NEMADIGITAL_INTENSITY_FILL,
      type: "fill",
      source: w.NEMADIGITAL_SOURCE,
      filter: ["match", ["geometry-type"], ["Polygon", "MultiPolygon"], !0, !1],
      paint: {
        "fill-color": "transparent"
      }
    },
    w.AREAS_BOUNDARY
  ));
}, ki = (e, n, t, a, i, o = !1) => {
  var c, s;
  const { sourceUrlPerField: l } = e;
  t.hasImage(dn) || t.loadImage(dn, (d, E) => {
    if (d || !E)
      throw d;
    t.addImage("bgCircle", E);
  }), o || Ii(t), Ui(t), i ? (Ri(t), xt(t, a, n, !0, i)) : (s = (c = n == null ? void 0 : n.geometry) == null ? void 0 : c.features) == null || s.filter((d) => !!(l != null && l[d.properties.id])).forEach((d) => {
    const { sourceId: E, layerId: f, intensityFillLayerId: T } = qn(d), h = l == null ? void 0 : l[d.properties.id];
    bi(h, E, f, T, t), Wn(t, a, d, !0);
  });
}, Ki = (e, n) => {
  const t = e.getSource(w.NEMADIGITAL_SOURCE);
  t && t.setData(n);
}, Wn = (e, n, t, a) => {
  const i = kt.map((c) => c.value), { layerId: o, intensityFillLayerId: l } = qn(t);
  e.setPaintProperty(o, "line-width", 0), e.setPaintProperty(l, "fill-opacity", 0), e.setPaintProperty(l, "fill-color", "transparent"), e.setPaintProperty(w.NEMADIGITAL_LAYER, "line-width", 0), e.setPaintProperty(w.NEMADIGITAL_INTENSITY_FILL, "fill-opacity", 0), e.setPaintProperty(w.NEMADIGITAL_INTENSITY_FILL, "fill-color", "transparent"), e.setLayoutProperty(w.NEMADIGITAL_DAMAGE_LABEL, "icon-image", "bgCircle"), a && n === se.CHOROPLETH_MAP ? (e.setPaintProperty(w.NEMADIGITAL_FILL, "fill-opacity", ["case", ["has", "nematodeColor"], 1, 0]), e.setPaintProperty(w.NEMADIGITAL_FILL, "fill-color", ["get", "nematodeColor"]), e.setFilter(w.NEMADIGITAL_DAMAGE_LABEL, ["has", "nematodeDamage"])) : a && n === se.INTENSITY_MAP && (e.setPaintProperty(o, "line-width", ["match", ["get", "value"], i, 1, 0]), e.setPaintProperty(l, "fill-opacity", 1), e.setPaintProperty(l, "fill-color", Zn()), e.setFilter(w.NEMADIGITAL_DAMAGE_LABEL, ["has", "nematodeDamage"]));
}, xt = (e, n, t, a, i) => {
  var l;
  const o = kt.map((c) => c.value);
  e.setPaintProperty(w.NEMADIGITAL_FILL, "fill-opacity", 0), e.setPaintProperty(w.NEMADIGITAL_FILL, "fill-color", "transparent"), e.setLayoutProperty(w.NEMADIGITAL_DAMAGE_LABEL, "icon-image", "bgCircle"), e.setFilter(w.NEMADIGITAL_DAMAGE_LABEL, ["has", "randomTag"]), i ? (e.setPaintProperty(w.NEMADIGITAL_LAYER, "line-width", 0), e.setPaintProperty(w.NEMADIGITAL_INTENSITY_FILL, "fill-opacity", 0), e.setPaintProperty(w.NEMADIGITAL_INTENSITY_FILL, "fill-color", "transparent"), a && n === se.CHOROPLETH_MAP ? (e.setPaintProperty(w.NEMADIGITAL_FILL, "fill-opacity", ["case", ["has", "nematodeColor"], 1, 0]), e.setPaintProperty(w.NEMADIGITAL_FILL, "fill-color", ["get", "nematodeColor"]), e.setFilter(w.NEMADIGITAL_DAMAGE_LABEL, ["has", "nematodeDamage"])) : a && n === se.INTENSITY_MAP && (e.setPaintProperty(w.NEMADIGITAL_LAYER, "line-width", [
    "match",
    ["get", "value"],
    o,
    1,
    0
  ]), e.setPaintProperty(w.NEMADIGITAL_INTENSITY_FILL, "fill-opacity", 1), e.setPaintProperty(w.NEMADIGITAL_INTENSITY_FILL, "fill-color", Zn()), e.setFilter(w.NEMADIGITAL_DAMAGE_LABEL, ["has", "nematodeDamage"]))) : (l = t.geometry) == null || l.features.forEach((c) => {
    Wn(e, n, c, a);
  });
}, Oi = m(v.FlexColumn)`
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 8px;
  backdrop-filter: blur(5px);

  justify-content: flex-start;
  align-items: flex-start;

  width: 280px;
  padding: 8px 12px 4px;
  gap: 4px;

  ${z.PositionControl}
`, Pi = m.div`
  display: inline-grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  width: 100%;
  
  & > :first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  & > :last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`, Hi = m.div`
  height: 8px;
  width: 100%;

  ${z.BackgroundControl}
`, Yi = m(v.FlexJustifyBetween)`
  width: 100%;
`, Gi = m(v.FlexJustifyCenter)`
  width: 100%;
`, ve = { Container: Oi, ColorsContainer: Pi, LegendColor: Hi, LegendGroupsContainer: Yi, LegendGroup: Gi }, Vi = ({ title: e, colors: n, legendsText: t, position: a, visible: i }) => i ? /* @__PURE__ */ r.createElement(ve.Container, N({}, a), /* @__PURE__ */ r.createElement(R.SubTitle, { $color: "#fff", $fontSize: "12px" }, e), /* @__PURE__ */ r.createElement(ve.ColorsContainer, null, n.map((o) => /* @__PURE__ */ r.createElement(ve.LegendColor, { key: o, $backgroundColor: o }))), /* @__PURE__ */ r.createElement(ve.LegendGroupsContainer, null, t.map((o) => /* @__PURE__ */ r.createElement(ve.LegendGroup, { key: o }, /* @__PURE__ */ r.createElement(R.Description, { $fontSize: "12px", $color: "#FFF" }, o))))) : null, Xn = m(v.FlexColumn)`
  background-color: rgba(20, 21, 28, 0.5);
  border-radius: 8px;
  backdrop-filter: blur(5px);

  justify-content: flex-start;
  align-items: flex-start;

  width: 200px;
  padding: 8px;
  ${z.PositionControl}
`, Qi = m(Xn)`
  padding: 12px;
`, Ji = m(v.FlexJustifyBetween)`
  width: 184px;
  margin-top: 4px;
`, _i = m(cr)`
  background-color: #232630;
  border-radius: 4px;

  width: 184px;
  height: 32px;

  margin-top: 12px;

  .ant-select-selector,
  .ant-select-selection {
    background-color: #232630 !important;
    border: 1px solid #232630 !important;
  }

  .ant-select-selection__rendered {
    display: flex;
    align-items: center;
  }
  .ant-select-selection-item,
  .ant-select-selection-selected-value {
    color: #fff !important;
    font: 400 14px sans-serif;
    display: flex;
  }

  .ant-select-arrow {
    color: #a3a9b9;
  }
`, zi = m(v.FlexAlignCenter)`
  width: 184px;
  height: 32px;
  padding-left: 16px;
  cursor: pointer;

  ${z.BackgroundControl}
`, ji = m(v.FlexCenter)`
  background-color: #fff;
  gap: 6px;
  width: 61px;
  height: 20px;
  border-radius: 4px;
  margin-bottom: 4px;
`, Zi = m.div`
  ${z.SizeControl}
  ${z.BorderControl}
  ${z.BackgroundControl}
`, qi = m(v.FlexAlignCenter)`
  gap: 4px;
`, ue = {
  Container: Xn,
  Title: Ji,
  MapTypeSelect: _i,
  DropdownOption: zi,
  AreaDamageTag: ji,
  StatusCircle: Zi,
  ConfidenceLevel: qi,
  ContainerStatus: Qi
}, Wi = (e) => /* @__PURE__ */ r.createElement("svg", N({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" }, e), /* @__PURE__ */ r.createElement("g", { clipPath: "url(#clip0_33030_53201)" }, /* @__PURE__ */ r.createElement("rect", { width: "24", height: "24", rx: "12", fill: "#CF3537" }), /* @__PURE__ */ r.createElement("rect", { width: "24", height: "24", rx: "12", fill: "#CF3537" }), /* @__PURE__ */ r.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9925 4.5C7.8525 4.5 4.5 7.86 4.5 12C4.5 16.14 7.8525 19.5 11.9925 19.5C16.14 19.5 19.5 16.14 19.5 12C19.5 7.86 16.14 4.5 11.9925 4.5ZM12.75 12.75V8.25H11.25V12.75H12.75ZM12.75 15.75V14.25H11.25V15.75H12.75ZM6 12C6 15.315 8.685 18 12 18C15.315 18 18 15.315 18 12C18 8.685 15.315 6 12 6C8.685 6 6 8.685 6 12Z",
    fill: "white"
  }
)), /* @__PURE__ */ r.createElement("defs", null, /* @__PURE__ */ r.createElement("clipPath", { id: "clip0_33030_53201" }, /* @__PURE__ */ r.createElement("rect", { width: "24", height: "24", rx: "12", fill: "white" })))), Xi = /* @__PURE__ */ r.createElement(On, { style: { fontSize: 24, color: "#FFF" }, spin: !0 }), $i = ({ translations: e, cropCycleResults: n }) => (n == null ? void 0 : n.status) === Rt.FAILED ? /* @__PURE__ */ r.createElement(v.FlexColumn, { "data-testid": ft.NEMA_MAP_STATUS_ERROR }, /* @__PURE__ */ r.createElement(v.FlexJustifyBetween, null, /* @__PURE__ */ r.createElement(Wi, null)), /* @__PURE__ */ r.createElement(R.Bold, { $margin: "4px 0px 12px 0px", $color: "#fff" }, e.errorProcessingAnalytics)) : /* @__PURE__ */ r.createElement(v.FlexColumn, { "data-testid": ft.NEMA_MAP_STATUS_LOADING }, /* @__PURE__ */ r.createElement(v.FlexJustifyBetween, null, /* @__PURE__ */ r.createElement(vt, { indicator: Xi })), /* @__PURE__ */ r.createElement(R.Bold, { $margin: "12px 0px 4px 0px", $color: "#fff" }, e.processingAnalytics), /* @__PURE__ */ r.createElement(R.Description, { $color: "#fff" }, e.messageProcessingAnalytics)), e1 = ({
  translations: e,
  mapTypes: n,
  position: t,
  selectedMap: a,
  selectedArea: i,
  cropCycleResults: o,
  qualityThresholds: l,
  onSelectMap: c,
  onClickEdit: s
}) => {
  const { confidenceLevel: d } = l || {
    confidenceLevel: {
      highConfidenceThreshold: 80,
      mediumConfidenceThreshold: 60
    }
  }, E = ne(() => {
    if (!i)
      return "";
    const f = o.confidenceLevelPerField[i];
    return f > d.highConfidenceThreshold ? "#19A04B" : f > d.mediumConfidenceThreshold ? "#FFCA28" : "#D73027";
  }, [i, o]);
  return /* @__PURE__ */ r.createElement(ue.Container, N({}, t), o && o.status !== Rt.FINISHED && /* @__PURE__ */ r.createElement(
    $i,
    {
      translations: e,
      cropCycleResults: o,
      onClickEdit: s
    }
  ), i ? /* @__PURE__ */ r.createElement(ue.Title, null, /* @__PURE__ */ r.createElement(v.FlexColumn, null, /* @__PURE__ */ r.createElement(ue.AreaDamageTag, null, /* @__PURE__ */ r.createElement(
    ue.StatusCircle,
    {
      $backgroundColor: E,
      $width: "6px",
      $height: "6px",
      $borderRadius: "3px"
    }
  ), /* @__PURE__ */ r.createElement(R.SubTitle, { $fontSize: "12px", $color: E }, o.confidenceLevelPerField[i], "%")), /* @__PURE__ */ r.createElement(ue.ConfidenceLevel, null, /* @__PURE__ */ r.createElement(R.Description, { $color: "#C2C7D0" }, e.imageQuality), /* @__PURE__ */ r.createElement(
    ue.StatusCircle,
    {
      $backgroundColor: E,
      $width: "8px",
      $height: "8px",
      $borderRadius: "4px"
    }
  ))), /* @__PURE__ */ r.createElement("div", { onClick: s, role: "presentation" }, /* @__PURE__ */ r.createElement(_e, { $cursor: "pointer" }))) : /* @__PURE__ */ r.createElement(r.Fragment, null, /* @__PURE__ */ r.createElement(ue.Title, null, /* @__PURE__ */ r.createElement(R.SubTitle, { $fontSize: "14px", $color: "#FFF" }, e.analyzedAreas), /* @__PURE__ */ r.createElement("div", { onClick: s, role: "presentation" }, /* @__PURE__ */ r.createElement(_e, { $cursor: "pointer" }))), /* @__PURE__ */ r.createElement(
    ue.MapTypeSelect,
    {
      dropdownStyle: { background: "#363948", padding: "4px 0" },
      onChange: (f) => c(f),
      value: a
    },
    Object.keys(n).map((f) => {
      const h = f === a ? R.Description : R.SubTitle;
      return /* @__PURE__ */ r.createElement(ue.MapTypeSelect.Option, { value: f, key: f }, /* @__PURE__ */ r.createElement(h, { $color: "#FFF", $fontSize: "14px" }, n[f]));
    })
  )));
}, t1 = m(v.FlexJustifyBetween)`
  background-color: rgba(20, 21, 28, 0.5);
  align-items: center;
  width: 200px;
  height: 40px;
  padding: 8px;
  border-radius: 8px;
  ${z.PositionControl}
`, n1 = { Container: t1 }, r1 = /* @__PURE__ */ r.createElement(On, { style: { fontSize: 24, color: "#FFF" }, spin: !0 }), a1 = ({ title: e, geojsonLoadingPosition: n }) => /* @__PURE__ */ r.createElement(n1.Container, N({}, n), /* @__PURE__ */ r.createElement(vt, { indicator: r1 }), /* @__PURE__ */ r.createElement(R.Bold, { $fontSize: "14px", $color: "#fff" }, e)), M1 = ({
  mapbox: e,
  showLayer: n,
  region: t,
  cropCycleResults: a,
  initialMapType: i,
  isMapboxReady: o,
  nemadigitalColors: l,
  nemadigitalDamageGroups: c,
  selectorPosition: s,
  legendPosition: d,
  translations: E,
  selectedArea: f,
  qualityThresholds: T,
  geojson: h,
  useSingleGeojson: g,
  isLoadingGeoJson: C,
  geojsonLoadingPosition: x,
  onSelectMapCallBack: S,
  onClickEdit: k,
  hasCropIdentificationEntitlement: F
}) => {
  const [I, P] = J(i || se.CHOROPLETH_MAP), [K, V] = J(!1), W = {
    [se.CHOROPLETH_MAP]: E ? E.damageMap : "",
    [se.INTENSITY_MAP]: E ? E.intensityMap : ""
  };
  re(() => {
    const L = !!t && !!t.geometry;
    o && L && !K && n && (ki(a, t, e, I, g, F), V(!0));
  }, [n, o, a, t, F]), re(() => {
    h && e && Ki(e, h);
  }, [h]), re(() => {
    f && n && K ? b(se.INTENSITY_MAP) : n && K ? b(I) : !n && K && xt(e, I, t, !1, g);
  }, [f, n]);
  const b = (L) => {
    P(L), xt(e, L, t, n, g), S && S(L);
  };
  return n ? /* @__PURE__ */ r.createElement(
    En,
    {
      theme: {
        components: {
          Select: {
            controlItemBgActive: "#198746",
            colorBgContainer: "#232630",
            controlOutline: "#232630",
            colorPrimary: "#232630",
            colorPrimaryHover: "#232630",
            colorBorder: "#232630",
            colorTextQuaternary: "#A3A9B9"
          }
        }
      }
    },
    !!s && /* @__PURE__ */ r.createElement(
      e1,
      {
        translations: E,
        mapTypes: W,
        position: s,
        selectedMap: I,
        cropCycleResults: a,
        selectedArea: f,
        onClickEdit: k,
        onSelectMap: b,
        qualityThresholds: T
      }
    ),
    !!d && /* @__PURE__ */ r.createElement(
      Vi,
      {
        visible: I === se.CHOROPLETH_MAP,
        title: E.legendTitle,
        colors: l,
        legendsText: c,
        position: d
      }
    ),
    !!C && /* @__PURE__ */ r.createElement(a1, { title: E.loadingGeojson, geojsonLoadingPosition: x })
  ) : null;
}, o1 = (n) => {
  var e = X(n, []);
  return /* @__PURE__ */ r.createElement(de.SVG, N({ width: "108", height: "108", viewBox: "0 0 108 108", fill: "none" }, e), /* @__PURE__ */ r.createElement("circle", { cx: "54", cy: "54", r: "54", fill: "#C3EAD1" }), /* @__PURE__ */ r.createElement(
    "mask",
    {
      id: "mask0_32105_208298",
      style: { maskType: "alpha" },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "108",
      height: "108"
    },
    /* @__PURE__ */ r.createElement("circle", { cx: "54", cy: "54", r: "54", fill: "#E8EAED" })
  ), /* @__PURE__ */ r.createElement("g", { mask: "url(#mask0_32105_208298)" }, /* @__PURE__ */ r.createElement(
    "path",
    {
      d: "M73.7324 90.4204C73.6966 87.8485 72.9938 86.0651 73.5945 80.5206L73.5568 77.8096L48.2846 64.2647C47.2883 65.7473 47.0286 73.0574 46.4647 74.8696C45.428 78.2012 45.0675 96.2426 44.7569 98.2806C44.4463 100.319 40.9437 121.31 41.0287 127.41L41.3401 149.776C41.3779 152.487 42.7152 167.382 43.3791 174.49L54.5628 174.335L54.3599 159.763C54.3033 155.696 53.3471 135.712 53.9635 131.297C54.4567 127.765 56.6695 114.651 57.7142 108.535C57.948 109.097 59.1463 113.423 59.575 115.699C61.0391 123.475 62.8222 134.563 62.8646 137.613L63.3743 174.212C67.9008 174.714 76.9464 175.175 76.9162 173.007L76.2744 126.919C76.2272 123.53 73.8079 95.8424 73.7324 90.4204Z",
      fill: "#00004B",
      stroke: "#00004B",
      strokeWidth: "0.892562"
    }
  )), /* @__PURE__ */ r.createElement(
    "path",
    {
      d: "M41.7611 49.576C47.9283 50.8588 44.509 46.2118 54.6567 46.2118C53.9688 46.8987 53.5813 51.0665 53.5813 52.69C53.5813 56.2611 52.5839 60.3307 51.7036 62.1648C50.3572 62.2104 42.3647 61.1787 40.6958 60.6298C38.6096 59.9437 29.5546 54.7154 27.9124 52.0728C26.2701 49.4302 33.1723 38.3211 34.0378 37.6501C34.9034 36.9791 37.7442 32.2432 37.6776 32.9858C37.6243 33.5799 40.3777 34.8083 41.7611 35.3482C43.1445 35.8881 40.749 39.8504 40.6958 40.4445C40.6425 41.0386 38.4986 44.7874 37.4333 47.6863C36.8267 47.4655 38.3877 48.8742 41.7611 49.576Z",
      fill: "white",
      stroke: "#00004B",
      strokeWidth: "0.892562"
    }
  ), /* @__PURE__ */ r.createElement(
    "path",
    {
      d: "M39.7131 64.4867L36.1622 54.1458C36.0826 53.9141 36.2548 53.6729 36.4998 53.6729H43.1944C43.3507 53.6729 43.4888 53.7745 43.5353 53.9237L47.127 65.4547L40.0144 64.7259C39.8759 64.7117 39.7583 64.6183 39.7131 64.4867Z",
      fill: "#00004B",
      stroke: "#00004B",
      strokeWidth: "0.892562"
    }
  ), /* @__PURE__ */ r.createElement(
    "path",
    {
      d: "M65.3821 40.6574C65.3821 40.6574 66.5288 39.2643 66.5119 38.9647C66.3944 36.8788 67.8907 35.3344 67.4312 33.6327C66.4556 30.0201 70.0365 33.6327 68.7274 28.1454C68.0872 25.4616 65.7693 25.6409 66.1092 26.8362C66.1145 26.8548 66.1193 26.8717 66.1238 26.8872C65.8995 26.1743 64.6573 22.5425 62.9458 22.2185C60.3319 21.7238 54.0287 23.2336 50.8991 27.4476C49.6788 29.0907 49.3352 29.7406 51.4631 36.0038C53.0347 40.6292 57.7143 42.1521 58.5023 42.6678L65.3821 40.6574Z",
      fill: "#E1E1E1"
    }
  ), /* @__PURE__ */ r.createElement(
    "path",
    {
      d: "M58.5023 42.6678C57.7143 42.1521 53.0347 40.6292 51.4631 36.0038C49.3352 29.7406 49.6788 29.0907 50.8991 27.4476C54.0287 23.2336 60.3319 21.7238 62.9458 22.2185C65.0531 22.6174 66.4491 28.0315 66.1092 26.8362C65.7693 25.6409 68.0872 25.4616 68.7274 28.1454C70.0365 33.6327 66.4556 30.0201 67.4312 33.6327C67.8907 35.3344 66.3944 36.8788 66.5119 38.9647C66.5288 39.2643 65.3821 40.6574 65.3821 40.6574L58.5023 42.6678ZM58.5023 42.6678C61.0377 44.3272 58.3227 42.5004 58.5023 42.6678Z",
      stroke: "#00004B",
      strokeWidth: "0.892562"
    }
  ), /* @__PURE__ */ r.createElement(
    "path",
    {
      d: "M68.0547 50.11C66.3722 48.4276 66.1912 38.5221 65.7106 40.4444C65.2499 42.2875 58.6597 43.8971 58.0641 42.5748C58.0589 42.4936 58.0449 42.4238 58.0211 42.3667C58.0211 42.4429 58.0359 42.5122 58.0641 42.5748C58.1653 44.1724 54.8166 50.2322 53.8425 52.6337L68.0547 50.11Z",
      fill: "#E1E1E1",
      stroke: "#00004B",
      strokeWidth: "0.892562"
    }
  ), /* @__PURE__ */ r.createElement(
    "path",
    {
      d: "M46.3069 55.0859C47.7481 55.5362 49.55 61.5721 50.7172 62.6531L50.7173 68.638C50.2623 68.4184 49.9423 66.8953 48.9057 66.3965C46.9078 65.4353 46.3069 65.2065 44.0835 64.4742C42.1474 63.8365 39.2775 63.0324 39.7581 61.11C39.9144 60.4848 41.3782 61.6895 41.6224 61.5721C41.8667 61.4547 37.3551 60.1488 38.3753 58.6408C38.9759 57.7531 42.8046 61.0319 42.8046 60.274C42.8046 59.9396 37.8041 57.9512 38.7969 56.7846C39.8691 55.5247 43.8024 59.8494 43.8024 58.9042C43.8024 58.6408 40.5173 56.8425 40.2387 56.304C39.8903 55.6309 40.3568 54.8846 41.3782 55.2093C41.7436 55.3255 43.8024 57.248 46.1653 58.1934C46.9593 58.5111 46.2253 57.4261 45.9466 56.8877C45.5983 56.2146 44.9343 54.6571 46.3069 55.0859Z",
      fill: "#E1E1E1",
      stroke: "#00004B",
      strokeWidth: "0.892562"
    }
  ), /* @__PURE__ */ r.createElement(
    "path",
    {
      d: "M79.5273 52.4581C78.3395 48.781 77.2364 45.1635 71.4212 45.6394L66.6716 45.7296C65.8934 46.6443 63.5871 50.9297 60.9044 50.5356C57.5402 50.0415 57.1518 46.2865 56.5791 45.7296C53.8663 45.6544 54.177 50.0505 53.6955 52.4581C52.7343 57.2641 50.3522 58.4767 50.2723 60.8505L47.1273 66.6156C53.3128 69.8584 65.7818 79.527 73.6144 81.4075C79.7258 82.8748 81.6198 80.7827 81.5868 78.4105C82.4728 70.219 80.9442 56.8447 79.5273 52.4581Z",
      fill: "white"
    }
  ), /* @__PURE__ */ r.createElement(
    "path",
    {
      d: "M50.2723 60.8505L47.1273 66.6156C53.3128 69.8584 65.7818 79.527 73.6144 81.4075C79.7258 82.8748 81.6198 80.7827 81.5868 78.4105C82.4728 70.219 80.9442 56.8447 79.5273 52.4581C78.3395 48.781 77.2364 45.1635 71.4212 45.6394L66.6716 45.7296C65.8934 46.6443 63.5871 50.9297 60.9044 50.5356C57.5402 50.0415 57.1518 46.2865 56.5791 45.7296C53.8663 45.6544 54.177 50.0505 53.6955 52.4581C52.7343 57.2641 50.3522 58.4767 50.2723 60.8505ZM50.2723 60.8505C53.1185 62.3926 60.5438 64.7071 62.1819 65.4978C63.6055 66.185 68.7814 68.4559 72.2051 70.1962C72.827 70.5123 73.5742 70.0436 73.5429 69.3466L73.3092 64.1452L73.5432 68.8008C73.5762 69.4575 72.9118 69.9233 72.3057 69.6684L65.0463 66.6156L50.2723 60.8505ZM50.2723 60.8505C49.471 59.0489 52.074 62.6521 50.2723 60.8505Z",
      stroke: "#00004B",
      strokeWidth: "0.892562"
    }
  ), /* @__PURE__ */ r.createElement(
    "path",
    {
      d: "M71.6391 61.6385C71.6235 60.5207 71.1466 50.6139 71.421 45.9778L67.4204 46.0335C67.2715 51.5717 67.7888 62.6367 67.2465 62.6443C66.7043 62.6518 59.6408 63.2974 54.2356 62.2916L63.8044 65.4344L72.7823 69.2792L73.3092 64.1456C72.986 65.2799 73.373 66.0934 72.7823 65.9567C71.6957 65.7051 71.6664 63.5996 71.6391 61.6385Z",
      fill: "#00004B",
      stroke: "#00004B",
      strokeWidth: "0.892562"
    }
  ), /* @__PURE__ */ r.createElement(
    "path",
    {
      d: "M54.5963 58.2259C54.5812 57.1415 55.326 49.9372 55.6177 46.5437L52.7946 46.5437C52.7946 46.5437 50.6769 57.4558 50.2722 60.8508L51.4449 61.1296L52.7946 61.5715L54.5963 62.2921C54.5884 61.7273 54.6114 59.3103 54.5963 58.2259Z",
      fill: "#00004B"
    }
  ), /* @__PURE__ */ r.createElement(
    "path",
    {
      d: "M52.7946 46.5437C52.7946 46.5437 50.6769 57.4558 50.2722 60.8508L51.4449 61.1296L52.7946 61.5715L54.5963 62.2921C54.5884 61.7273 54.6114 59.3103 54.5963 58.2259C54.5812 57.1415 55.326 49.9372 55.6177 46.5437L52.7946 46.5437ZM52.7946 46.5437C50.8705 46.5672 54.7186 46.5201 52.7946 46.5437Z",
      stroke: "#00004B",
      strokeWidth: "0.892562"
    }
  ), /* @__PURE__ */ r.createElement(
    "path",
    {
      d: "M54.0001 25.1999C53.1726 26.967 50.8504 28.6393 49.3597 29.1272V32.8598C49.3597 33.8354 46.3782 32.372 45.8813 28.4694C45.4837 25.3473 47.0407 23.9164 48.3658 23.1033C47.372 21.6398 48.4652 19.3959 50.8504 18.2251C53.8319 16.7616 55.8196 19.2008 55.8196 18.2251C55.8196 17.2494 57.3103 15.2982 60.7887 15.786C64.2672 16.2738 62.4347 20.1003 64.2672 19.2008C66.2549 18.2251 70.2302 20.1764 69.2364 23.5911C68.6903 25.4674 71.3226 25.5457 70.691 29.1272C69.8307 34.0054 66.0972 33.8695 67.091 33.3817C67.5879 33.1378 65.2618 32.7978 68.0728 31.4181C70.0605 30.4424 67.7456 23.5911 66.1092 27.4908C66.1092 28.1412 64.5158 25.7791 62.9256 24.2181C60.938 22.2668 62.5092 22.5817 60.2183 24.2181C57.3851 26.2418 54.9819 23.1033 54.0001 25.1999Z",
      fill: "#00004B",
      stroke: "#00004B",
      strokeWidth: "0.892562"
    }
  ), /* @__PURE__ */ r.createElement(
    "path",
    {
      d: "M62.7888 34.9509C65.4829 35.2413 67.41 31.7488 67.4631 32.1424C68.6944 32.9334 68.0218 38.673 65.6034 41.0577C63.185 43.4424 60.4915 43.6432 58.0229 43.176C55.0853 42.6201 53.1085 40.1109 52.6613 38.8263C52.1269 37.2915 52.223 36.4855 52.232 35.9434C53.065 36.089 54.096 36.786 55.0768 37.2634C56.4344 37.9241 57.4846 38.3761 59.2807 37.1159C60.3753 36.348 61.1935 34.779 62.7888 34.9509Z",
      fill: "#00004B",
      stroke: "#00004B",
      strokeWidth: "0.892562"
    }
  ), /* @__PURE__ */ r.createElement(
    "path",
    {
      d: "M53.3459 35.0808C54.724 34.587 55.6584 34.7381 56.9088 35.2442C56.6698 35.8397 55.332 36.9891 54.4279 37.2255C53.5239 37.462 52.1129 37.2537 51.2219 36.9538C50.8039 37.029 52.4162 35.4138 53.3459 35.0808Z",
      fill: "#00004B",
      stroke: "#00004B",
      strokeWidth: "0.892562"
    }
  ), /* @__PURE__ */ r.createElement(
    "path",
    {
      d: "M60.4332 36.448C58.4116 36.3208 57.7368 35.5319 56.9661 35.16C57.3664 34.6585 58.7766 34.002 60.1133 34.0859C62.1349 34.2128 62.5817 34.553 63.8694 35.1802C63.1354 35.6805 62.4549 36.5752 60.4332 36.448Z",
      fill: "#00004B",
      stroke: "#00004B",
      strokeWidth: "0.892562"
    }
  ), /* @__PURE__ */ r.createElement(
    "path",
    {
      d: "M41.0463 27.7093C39.5285 28.7566 38.3586 32.0729 37.9634 33.6001C38.2005 33.8183 38.8171 34.2983 39.3863 34.4728C39.9554 34.6474 41.3625 35.1273 41.9949 35.3455C42.232 34.7637 42.8486 33.6001 43.4177 33.6001C44.1292 33.6001 44.8964 33.3938 45.552 32.291C45.7759 31.9145 46.5006 30.7638 46.2635 29.8911C46.0263 29.0184 44.6593 28.6814 44.8964 28.0268C45.1336 27.3723 47.2274 28.0268 48.3629 28.0268C48.8582 28.0268 49.9414 26.8414 47.8677 26.0753C43.906 24.6115 42.9434 26.4002 41.0463 27.7093Z",
      fill: "#E1E1E1",
      stroke: "#00004B",
      strokeWidth: "0.892562"
    }
  ));
}, i1 = m.div`
  background-color: rgba(20, 21, 28, 0.5);
  border-radius: 12px;

  width: 388px;
  padding: 20px;

  position: ${(e) => e.$position};
  right: ${(e) => e.$right};
  left: ${(e) => e.$left};
  top: ${(e) => e.$top};
  bottom: ${(e) => e.$bottom};
  z-index: ${(e) => e.$zIndex};
`, l1 = m.div`
  width: 108px;
  margin-right: 20px;
`, c1 = m(bn)`
  color: #fff;
`, st = { Container: i1, LogoContainer: l1, CloseIcon: c1 }, v1 = ({
  title: e,
  subTitle: n,
  textButton: t,
  onClick: a,
  onClose: i,
  showCloseButton: o,
  position: l,
  right: c,
  top: s,
  bottom: d,
  left: E,
  zIndex: f
}) => /* @__PURE__ */ r.createElement(ze, null, /* @__PURE__ */ r.createElement(
  st.Container,
  {
    "data-testid": Ye.NEMA_CTA_CONTAINER,
    $position: l,
    $right: c,
    $top: s,
    $bottom: d,
    $left: E,
    $zIndex: f
  },
  /* @__PURE__ */ r.createElement(v.Flex, null, /* @__PURE__ */ r.createElement(st.LogoContainer, null, /* @__PURE__ */ r.createElement(o1, null)), /* @__PURE__ */ r.createElement("div", null, /* @__PURE__ */ r.createElement(R.SubTitle, { $color: "#fff", $marginBottom: "8px" }, e), /* @__PURE__ */ r.createElement(R.Description, { $color: "#fff", $marginBottom: "16px" }, n), /* @__PURE__ */ r.createElement(
    le,
    {
      "data-testid": Ye.NEMA_CTA_BUTTON,
      ghost: !0,
      $height: "30px",
      $width: "auto",
      icon: /* @__PURE__ */ r.createElement(Je, null),
      onClick: a
    },
    t
  )), o && /* @__PURE__ */ r.createElement(
    le,
    {
      "data-testid": Ye.NEMA_CTA_CLOSE_BUTTON,
      type: "text",
      $height: "16px",
      $width: "16px",
      icon: /* @__PURE__ */ r.createElement(st.CloseIcon, null),
      onClick: i
    }
  ))
)), s1 = m.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background-color: rgba(20, 21, 28, 0.5);
  border-radius: 8px;

  width: 228px;

  position: ${(e) => e.$position};
  right: ${(e) => e.$right};
  left: ${(e) => e.$left};
  top: ${(e) => e.$top};
  bottom: ${(e) => e.$bottom};
  z-index: ${(e) => e.$zIndex};
`, d1 = m(Fa)`
  color: ${(e) => e.disabled ? "#696F88" : "#fff"};
`, E1 = m(Yn)`
  color: ${(e) => e.disabled ? "#696F88" : "#fff"};
`, f1 = m.div`
  display: flex;
  justify-content: space-between;
  width: 40px;
`, He = { Container: s1, ContainerButtons: f1, PreviousButton: d1, NextButton: E1 }, F1 = ({
  seasons: e,
  callbackChangeSeason: n,
  startIndex: t,
  position: a,
  right: i,
  top: o,
  bottom: l,
  left: c,
  zIndex: s
}) => {
  const [d, E] = J(t || 0), f = d === 0, T = e.length <= d + 1, h = () => {
    const C = d + 1;
    T || (E(C), n(e[C]));
  }, g = () => {
    const C = d - 1;
    f || (E(C), n(e[C]));
  };
  return /* @__PURE__ */ r.createElement(
    He.Container,
    {
      "data-testid": Ge.NEMA_SELECT_SEASON_CONTAINER,
      $position: a,
      $right: i,
      $top: o,
      $bottom: l,
      $left: c,
      $zIndex: s
    },
    /* @__PURE__ */ r.createElement(R.Bold, { $color: "#fff" }, e[d]),
    e.length > 1 && /* @__PURE__ */ r.createElement(He.ContainerButtons, null, /* @__PURE__ */ r.createElement(
      He.PreviousButton,
      {
        disabled: f,
        onClick: g,
        "data-testid": Ge.NEMA_SELECT_SEASON_PREVIOUS_BUTTON
      }
    ), /* @__PURE__ */ r.createElement(
      He.NextButton,
      {
        disabled: T,
        onClick: h,
        "data-testid": Ge.NEMA_SELECT_SEASON_NEXT_BUTTON
      }
    ))
  );
}, u1 = m.div`
  background-color: ${j.WHITE};
  border-radius: 16px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  max-height: 520px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  z-index: 999;
`, h1 = m.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 998;
`, m1 = m.div`
  position: relative;
  display: inline-block;
  width: 100%;
`, g1 = m.img`
  height: auto;
  width: 100%;
  border-radius: 8px 8px 0 0;
  object-fit: cover;
`, C1 = m(le)`
  position: absolute;
  top: 16px;
  right: 16px;
  border-radius: 30px;
  background-color: ${j.NEUTRAL_10};
  color:  ${j.NEUTRAL_100};
  width: 38px !important;
  height: 38px !important;
  display: flex;
  padding: 10px;
  align-items: center;
  gap: 10px;
  justify-content: center;
`, A1 = m.div`
  display: flex;
  flex-direction: column;
  padding: 16px 24px;
  gap: 12px;

  .strong {
    font-weight: bold;
  }
`, p1 = m.div`
  display: flex;
  justify-content: end;
`, S1 = m(le)`
  width: 120px;
  padding: 10px 16px;
  color: ${j.NEUTRAL_60};
`, T1 = m(le)`
  width: 120px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
`, he = { Container: u1, Overlay: h1, ImageWrapper: m1, ImageContainer: g1, CloseButton: C1, Content: A1, ContentButtonActions: p1, NotNowButton: S1, ConfigureButton: T1 }, y1 = "data:image/png;base64,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", w1 = ({ translation: e, onConfigureCdl: n, onCloseCdl: t }) => /* @__PURE__ */ r.createElement(ze, null, /* @__PURE__ */ r.createElement(he.Overlay, null), /* @__PURE__ */ r.createElement(he.Container, { "data-testid": Qe.NEMA_CDL_CONTAINER }, /* @__PURE__ */ r.createElement(he.ImageWrapper, null, /* @__PURE__ */ r.createElement(he.ImageContainer, { src: y1, alt: "" }), /* @__PURE__ */ r.createElement(he.CloseButton, { type: "ghost", icon: /* @__PURE__ */ r.createElement(bn, null), onClick: t })), /* @__PURE__ */ r.createElement(he.Content, null, /* @__PURE__ */ r.createElement(R.Title, { color: "#000", $fontSize: "20px" }, e.title), /* @__PURE__ */ r.createElement(R.Description, null, e.subTitle), /* @__PURE__ */ r.createElement(R.Description, null, e.description), /* @__PURE__ */ r.createElement(R.Description, null, e.subDescription), /* @__PURE__ */ r.createElement(he.ContentButtonActions, null, /* @__PURE__ */ r.createElement(he.NotNowButton, { "data-testid": Qe.NEMA_CDL_CANCEL_BUTTON, type: "ghost", onClick: t }, e.cancelTextButton), /* @__PURE__ */ r.createElement(
  he.ConfigureButton,
  {
    "data-testid": Qe.NEMA_CDL_OK_BUTTON,
    type: "primary",
    icon: /* @__PURE__ */ r.createElement(Je, null),
    onClick: n
  },
  e.okTextButton
)))));
export {
  Rt as JobStatusEnum,
  M1 as MapOverlay,
  w1 as NemaCDL,
  v1 as NemaCTA,
  L1 as NemaConfig,
  F1 as NemaSelectSeason,
  ro as SetupForm
};
